import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import systemField, {ForceActiveSystemFields} from '@/common/constant/SystemField';
import CorporationUtils from '@/common/utils/CorporationUtils';
import {
    getFormListByCorporation,
    updateFormsData,
    getFormById,
    updateFormField,
} from '@/service/formManagementService';
import { getAllProjectListInCorporation } from '@/service/projectService';
import { cloneDeep } from 'lodash';
import {
    isAddNewField,
    buildCreateItemStatusRequest,
    buildCreateItemTagRequest,
    validateFieldList,
    sortFieldListByOrder,
    updateParentFieldList
} from './CommonHandler';
import { TmpHiddenSystemField, AISystemField } from '../../../common/constant/SystemField';
import { getRecoil } from 'recoil-nexus';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import localStorageUtil from '@/common/utils/localStorageUtil';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

/**Handler logic FormList - start*/

const shareForOrgOption = [Constant.SHARE_OPTION.SPECIFIC_ORG, Constant.SHARE_OPTION.B2B_CUSTOMER_ORG, Constant.SHARE_OPTION.B2B_HELPDESK_ORG];

const COMMON_AI_FIELDS = [
    Constant.SYSTEM_FIELD.AI_PROMPT_BODY,
    Constant.SYSTEM_FIELD.APPLY_AI_PROMPT,
    Constant.SYSTEM_FIELD.AI_PROMPT_APPLICATION_TARGET,
    Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION,
    Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS,
    Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING
];

const COMMON_ESCALATION_FIELDS = [
    Constant.SYSTEM_FIELD.ESCALATION_ORIGIN_CUSTOMER,
    Constant.SYSTEM_FIELD.ESCALATION_TARGET,
    Constant.SYSTEM_FIELD.PROXIED_USER
];

const TELEPHONE_FIELDS = [
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_STATUS,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_TYPE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_MODE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_HANDLER,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FROM,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.TO,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FOLLOW_UP_STATUS,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.REVIEW_STATUS,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.EVALUATOR,
    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.HOLD_COUNT
];

const KB_KNOWLEDGE_FIELDS = [
    Constant.SYSTEM_FIELD.KB_SHEET_NAME,
    Constant.SYSTEM_FIELD.KB_SHEET_ID,
    Constant.SYSTEM_FIELD.KB_XML,
    Constant.SYSTEM_FIELD.KB_XML_TIMESTAMP
];

const AI_TELEPHONE_SYSTEM_FIELDS = Object.values(Constant.AI_TELEPHONE_PROMPT_SYSTEM_FIELD);

export const getInitDataFilterFormLevel = async (args, projectList) => {
    //get list project in corp
    if (Utils.isEmptyArray(projectList)) {
        const corporationId = localStorageUtil.getAffiliationOrganization();
        projectList = await getAllProjectListInCorporation(null, corporationId);
        if (args?.setProjectList) {
            projectList = Utils.sortListByNameDictionaryASC(projectList);
            args.setProjectList(projectList);
        }
    }

    let projectListClone = cloneDeep(projectList);
    projectListClone = projectListClone.filter(project => project?.active !== Constant.ACTIVE_FLAG.DELETED)
    //sort by createdAt
    projectListClone = sortListByDictionary(projectListClone);

    // move project inuse to top list
    let projectInuseIndex = projectListClone.findIndex((p) => p.id === args.projectInuseDetail.id);
    let [projectInuse] = projectListClone.splice(projectInuseIndex, 1);
    projectListClone.unshift(projectInuse);

    args.setListProjectInCorp(projectListClone);
};

export const onChangeFilterFormType = (formType, listForm, argsCommon) => {
    let argsFormFilterClone = cloneDeep(argsCommon.argsFormFilter);
    argsFormFilterClone.formType = formType;

    let filterList = cloneDeep(listForm);
    let resultList = [];

    let projectInuseDetail = argsCommon?.projectInuseDetail;
    let corporationDetail = argsCommon?.corporationDetail;
    let isOnEmailTicketMode = Utils.isEnableCreateEmailTicketMode(corporationDetail, projectInuseDetail);

    //Filter formType
    resultList = filterListFormByFormType(filterList, argsFormFilterClone.formType, argsCommon?.projectInuseDetail?.id, isOnEmailTicketMode);
    let listFormByType = sortActiveFormsByOrder(resultList, argsCommon);

    //set list form by type
    argsCommon.setListFormByType(listFormByType);

    //filter by current value formLevel and formStatus
    resultList = filterListFormByLevelAndStatus(
        resultList,
        argsFormFilterClone.formLevel,
        argsFormFilterClone.formStatus
    );
    argsCommon.setListFormByFilter(resultList);
    argsCommon.setArgsFormFilter(argsFormFilterClone);
};

export const onChangeFilterFormLevel = (formLevel, argsCommon) => {
    let argsFormFilterClone = cloneDeep(argsCommon.argsFormFilter);
    argsFormFilterClone.formLevel = formLevel;

    let filterList = cloneDeep(argsCommon.listFormByType);
    let resultList = [];

    resultList = filterListFormByLevelAndStatus(
        filterList,
        argsFormFilterClone.formLevel,
        argsFormFilterClone.formStatus
    );

    argsCommon.setListFormByFilter(resultList);
    argsCommon.setArgsFormFilter(argsFormFilterClone);
};

export const onChangeFilterFormStatus = (formStatus, argsCommon) => {
    let argsFormFilterClone = cloneDeep(argsCommon.argsFormFilter);
    argsFormFilterClone.formStatus = formStatus;

    let filterList = cloneDeep(argsCommon.listFormByType);
    let resultList = [];

    resultList = filterListFormByLevelAndStatus(
        filterList,
        argsFormFilterClone.formLevel,
        argsFormFilterClone.formStatus
    );

    argsCommon.setListFormByFilter(resultList);
    argsCommon.setArgsFormFilter(argsFormFilterClone);
};

export const filterListFormByFormType = (
    filterList,
    formType,
    projectInuseId,
    isOnEmailTicketMode = false
) => {
    let corporationDetail = getRecoil(corporationAtom);
    let projectInuseDetail = getRecoil(projectInuseDetailAtom);
    let resultList = [];
    if (formType === Constant.FILTER_LIST_FORM_TYPE.FORM_SYSTEM) {
        resultList = filterList.filter(
            form =>{
                        // Telephone form: only show when org-level Voice Agent is ON
                        if (Utils.isSystemTelephoneForm(form)) {
                            return (
                                Utils.isEnableSettingTelephoneAgent(corporationDetail)
                            );
                        }

                        if (Utils.isSystemBusinessAppForm(form)) return true;

                        if (Utils.isSystemFormKBoardPrompt(form)) {
                            return Utils.isCorporationOnKBoardPrompt(corporationDetail);
                        }

                       // KB Knowledge format: only show when K-Board function is ON
                       if (Utils.isSystemKBoardKnowledgeForm(form)) {
                           return Utils.isEnableUsingKBoard(corporationDetail);
                       }

                       // Allow AI_TELEPHONE_PROMPT to show in inactive list even when conditions are not met
                       if (
                           Utils.isSystemFormAITelephonePrompt(form)
                       ) {
                           if (
                               !Utils.isCorporationOnKnowledge(corporationDetail) ||
                               !Utils.isEnableSettingTelephoneAgent(corporationDetail)
                           ) {
                               return false;
                           }
                       }
                       if (Utils.isSystemFormAITrainingPrompt(form)) {
                           if (
                               !Utils.isCorporationOnKnowledge(corporationDetail) ||
                               !Utils.isEnableSettingTelephoneAgent(corporationDetail) ||
                               !Utils.isProjectDeskOn(projectInuseDetail)
                           ) {
                               return false;
                           }
                       }
                       if (Utils.isSystemFormAIAssistantPrompt(form)) {
                           if (
                               !Utils.isCorporationOnKnowledge(corporationDetail) ||
                               !Utils.isEnableSettingTelephoneAgent(corporationDetail) ||
                               !Utils.isProjectDeskOn(projectInuseDetail) || 
                               !Utils.isCorporationOnAIAuto(corporationDetail)
                           ) {
                               return false;
                           }
                       }


                       if (
                           (Utils.isSystemAIAutoForm(form) &&
                               !Utils.isCorporationOnAIAuto(corporationDetail)) ||
                           (Utils.isSystemSDAutoForm(form) &&
                               !Utils.isCorporationOnSDAuto(corporationDetail))
                       ) {
                           return false;
                       }

                       if (
                           form.type === formType ||
                           [
                               Constant.FORM_TYPE.FILE_FORMAT,
                               Constant.FORM_TYPE.PAGE_FORMAT,
                               Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER,
                               Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST,
                               Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK,
                               Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK,
                               Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER
                           ].includes(form.type) ||
                           (form.type === Constant.FORM_TYPE.EMAIL_FORMAT &&
                               isOnEmailTicketMode &&
                               form.affiliationProject === projectInuseId) ||
                           (form.type === Constant.FORM_TYPE.FORM_KNOWLEDGE &&
                               form.definition === Constant.FORM_DEFINITION.SYSTEM &&
                               Utils.isCorporationOnKnowledge(corporationDetail) &&
                               Utils.isCorporationOnAI(corporationDetail))
                       )
                           return true;

                       return false;
                   }
        );
    } else {
        resultList = filterList.filter(form => {
            if (formType === Constant.FORM_TYPE.FORM_KNOWLEDGE) {
                return (
                    (form.type === Constant.FORM_TYPE.FORM_KNOWLEDGE ||
                        form.type === Constant.FORM_TYPE.FORM_MASTER) &&
                    form.definition !== Constant.FORM_DEFINITION.SYSTEM
                );
            } else {
                // Exclude TELEPHONE_FORMAT from FORM_REQ_QA list (it should only appear in FORM_SYSTEM)
                if (formType === Constant.FORM_TYPE.FORM_REQ_QA && Utils.isSystemTelephoneForm(form)) {
                    return false;
                }
                return form.type === formType;
            }
        });
    }
    
    return resultList;
};

export const filterListFormByLevelAndStatus = (listForm, formLevel, formStatus) => {
    let listFormClone = cloneDeep(listForm);

    //Filter form level
    if (formLevel !== 'all') {
        if (
            formLevel === Constant.FORM_DEFINITION.SYSTEM ||
            formLevel === Constant.FORM_DEFINITION.SAMPLE
        ) {
            listFormClone = listFormClone.filter((form) => form.definition === formLevel);
        } else {
            listFormClone = listFormClone.filter((form) => form.affiliationProject === formLevel || form.affiliationOrganization === formLevel);
        }
    }

    //Filter form status and
    if (formStatus !== 'all') {
        if (formStatus === 'use') {
            listFormClone = listFormClone.filter((form) => {
                let usingTickets = JSON.parse(form.usingTickets);
                return !Utils.isEmptyObject(usingTickets);
            });
        } else {
            listFormClone = listFormClone.filter((form) => {
                let usingTickets = JSON.parse(form.usingTickets);
                return Utils.isEmptyObject(usingTickets);
            });
        }
    }

    return listFormClone;
};

// sort list by order
export const sortActiveFormsByOrder = (list, args, projectInuse) => {
    let projectId = projectInuse ? projectInuse : args?.projectInuseDetail?.id;

    if (list.length > 1) {
        let listResult = list.sort((formA, formB) => {
            let orderA = JSON.parse(formA.order) ? JSON.parse(formA.order)[projectId] : null;
            let orderB = JSON.parse(formB.order) ? JSON.parse(formB.order)[projectId] : null;
            
            if (orderA === orderB) {
                return new Date(formB.createdAt) - new Date(formA.createdAt);
            }

            return orderA - orderB;
        })

        return listResult;
    } else {
        return list;
    }
}

// sort list by alphabetical order
export const sortListByDictionary = (list) => {
    return list.sort((a, b) => {
        let nameA = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, a.name);
        let nameB = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, b.name);
        return nameA.localeCompare(nameB);
    });
}

export const onDragEndFormListHandler = (result, args) => {
    if (!result.destination) return;

    //is change data
    args.setIsChangeData(true);
    let projectInuseId = args.projectInuseDetail.id;

    //get start item and end item in listFormActive 
    let listActiveFormClone = cloneDeep(args.listFormActive);
    let startItemInListFormActive = listActiveFormClone[result.source.index];
    let endItemInListFormActive = listActiveFormClone[result.destination.index];
    const listActiveFormCloneSorted = moveItemArray(listActiveFormClone,result.source.index,result.destination.index)

    //get start item and end item in listFormByType
    let listFormByTypeClone = cloneDeep(args.listFormByType);
    let startIndex = listFormByTypeClone.findIndex(form => form.id === startItemInListFormActive.id);
    let endIndex = listFormByTypeClone.findIndex(form => form.id === endItemInListFormActive.id);

    let [formMove] = listFormByTypeClone.splice(startIndex, 1);
    listFormByTypeClone.splice(endIndex, 0, formMove);

    //update order value for form active
    listFormByTypeClone = updateOrderForListFormActiveWhenDragDrop(listFormByTypeClone, projectInuseId,listActiveFormCloneSorted);
    args.setListFormByType(listFormByTypeClone);

    //update All list form
    let listAllFormClone = cloneDeep(args.listAllForm);
    listAllFormClone.forEach(form => {
        let formFind = listFormByTypeClone.find(x => x.id === form.id);
        if (formFind) {
            form.order = formFind.order;
        }
    });
    args.setListAllForm(listAllFormClone);

    let [removed] = listActiveFormClone.splice(result.source.index, 1);
    listActiveFormClone.splice(result.destination.index, 0, removed);
    args.setListFormActive(listActiveFormClone);
}

const moveItemArray = (array, start, end) => {
    let cloneArray = [...array];
    let moveArray = [];
    let firstPathArray = [];
    let lastPathArray = [];

    if (start === end) {
        return cloneArray;
    }

    if (start > end) {
        cloneArray.forEach((item, index) => {
            if (index < end) {
                firstPathArray.push(item);
            }
            if (end <= index && index < start) {
                moveArray.push(item);
            }
            if (index > start) {
                lastPathArray.push(item);
            }
        });
        moveArray.unshift(cloneArray[start]);
    }

    if (end > start) {
        cloneArray.forEach((item, index) => {
            if (index < start) {
                firstPathArray.push(item);
            }

            if (start < index && index <= end) {
                moveArray.push(item);
            }
            if (index > end) {
                lastPathArray.push(item);
            }
        });
        moveArray.push(cloneArray[start]);
    }
    const array1 =  [...firstPathArray, ...moveArray, ...lastPathArray]
    return array1;
};


export const onChangeActiveForm = (isActive, formId, args) => {
    args.setIsChangeData(true);
    let projectInuseId = args.projectInuseDetail.id;

    //update listFormByType
    let listFormByTypeClone = cloneDeep(args.listFormByType);
    let indexForm = listFormByTypeClone.findIndex(x => x.id === formId);
    let formUpdate = listFormByTypeClone[indexForm];
    formUpdate.isProjectInuse = isActive;

    //move from to last array
    listFormByTypeClone.splice(indexForm, 1);
    listFormByTypeClone.push(formUpdate)

    //update order value for form active
    // Fix bug: When filter is System form and activating a form, set order = Date.now() (timestamp)
    // instead of using updateOrderForListFormActiveWhenDragDrop.
    // Reason: updateOrderForListFormActiveWhenDragDrop relies on args.listFormActive which is stale state
    // (not yet re-rendered), so activating multiple forms in a row causes them all to get the same order
    // (= listFormActive.length), resulting in duplicate orders and incorrect sorting (falls back to createdAt).
    // Using timestamp ensures each newly activated form always gets a unique order larger than all existing ones,
    // so it appears at the end of the active list as expected.
    // Note: When user drag-drops later, updateOrderForListFormActiveWhenDragDrop will re-index all orders
    // back to sequential numbers (1, 2, 3...), so timestamp values are naturally normalized.
    let argsFormFilter = args.argsFormFilter;
    if (argsFormFilter?.formType === Constant.FILTER_LIST_FORM_TYPE.FORM_SYSTEM && isActive) {
        let order = Utils.convertJSONDataToObject(formUpdate.order) || {};
        order[projectInuseId] = Date.now();
        formUpdate.order = JSON.stringify(order);
    } else {
        listFormByTypeClone = updateOrderForListFormActiveWhenDragDrop(listFormByTypeClone, projectInuseId, args.listFormActive);
    }

    //get list form by filter.
    let listFormByFilter = [];
    listFormByFilter = filterListFormByLevelAndStatus(
        listFormByTypeClone,
        argsFormFilter?.formLevel,
        argsFormFilter?.formStatus
    );

    //update list All form
    let listAllFormClone = cloneDeep(args.listAllForm);
    let index = listAllFormClone.findIndex(x => x.id === formId);
    let formTemp = listFormByTypeClone.find(x => x.id === formId);
    listAllFormClone[index] = formTemp;
    args.setListAllForm(listAllFormClone);
    args.setListFormByFilter(listFormByFilter);
    args.setListFormByType(listFormByTypeClone);
}

export const onChangeActiveListForm = (isActive, formIdList, args) => {
    let projectInuseId = args.projectInuseDetail.id;

    //update listFormByType
    let listFormByTypeClone = cloneDeep(args.listFormByType);
    let listFormByFilter = [];
    let listAllFormClone = cloneDeep(args.listAllForm)
    for (let i = 0; i < formIdList.length; i++) {
        const formId = formIdList[i];

        let indexForm = listFormByTypeClone.findIndex(x => x.id === formId);
        let formUpdate = listFormByTypeClone[indexForm];
        formUpdate.isProjectInuse = isActive;

        //move from to last array
        listFormByTypeClone.splice(indexForm, 1);
        listFormByTypeClone.push(formUpdate)

        //update order value for form active
        listFormByTypeClone = updateOrderForListFormActiveWhenDragDrop(listFormByTypeClone, projectInuseId,args.listFormActive);

        //get list form by filter.
        let argsFormFilter = args.argsFormFilter;
        listFormByFilter = filterListFormByLevelAndStatus(
            listFormByTypeClone,
            argsFormFilter.formLevel,
            argsFormFilter.formStatus
        );

        //update list All form
        let index = listAllFormClone.findIndex(x => x.id === formId);
        let formTemp = listFormByTypeClone.find(x => x.id === formId);
        listAllFormClone[index] = formTemp;
        
    }

    args.setListAllForm(listAllFormClone);
    args.setListFormByFilter(listFormByFilter);
    args.setListFormByType(listFormByTypeClone);
}

const updateOrderForListFormActive = (listFormByType, projectInuseId) => {
    let number = 1;
    listFormByType.forEach(form => {
        if (form.isProjectInuse) {
            let order = JSON.parse(form.order);
            if (order && order.hasOwnProperty(projectInuseId)) {
                order[projectInuseId] = number;
            } else {
                let newOrder = {
                    [projectInuseId]: number,
                };
                order = { ...order, ...newOrder };
            }
            form.order = JSON.stringify(order);
            number++;
        }
    })

    return listFormByType;
}

const updateOrderForListFormActiveWhenDragDrop = (listFormByType, projectInuseId,listFormActive) => {
    let newOrderValue = listFormActive.length;
    listFormByType.forEach(form => {
        if (form.isProjectInuse) {
            let order = JSON.parse(form.order);
            if (order && order.hasOwnProperty(projectInuseId)) {
             const index = listFormActive.findIndex((formActive) =>{
                return formActive.id === form.id
             })   
             if(index !== -1){
                order[projectInuseId] = index+1;
             }
            }else{
                let newOrder = {
                    [projectInuseId]: newOrderValue +1 ,
                };
                order = { ...order, ...newOrder };  
                newOrderValue++
            }
            form.order = JSON.stringify(order);
        }
    })

    return listFormByType;
}

export const onSubmitListForm = async (argsAll) => {
    let projectInuseId = argsAll.projectInuseDetail.id;
    // let listFormByType = argsAll.listFormByType;
    let listFormClone = [...argsAll.listForm];

    //list all form update
    let listUpdate = argsAll.listAllForm.filter((form) => {
        let formInactiveOrder = JSON.parse(form.order) ? JSON.parse(form.order)[projectInuseId] : null;
        let formInListForm = listFormClone.find((x) => x.id === form.id);
        let formOrder = JSON.parse(formInListForm.order)
            ? JSON.parse(formInListForm.order)[projectInuseId]
            : null;

        return (
            formInactiveOrder !== formOrder || form.isProjectInuse !== formInListForm.isProjectInuse
        );
    });
    argsAll.setIsLoading(true);
    const listFormOrigin = await Promise.all(
        listUpdate.map(async (form) => {
            let originForm = await getFormById(argsAll.API, form.id,null,true,projectInuseId)
            return originForm
        })
    );
    let listFormUpdate = [];
    let listFormCannotInactive = []
    let isHasFormUsingCategory = false

    for (let index = 0; index < listUpdate.length; index++) {
        const form = listUpdate[index];
        const originForm = listFormOrigin?.find(formData => formData.id === form.id);
        let formOrder = JSON.parse(form.order);
        let usingProjects = !Utils.isEmptyArray(originForm?.usingProjects) ? [...originForm?.usingProjects] : [];

        if (form.isProjectInuse) {
            form.order = JSON.stringify(formOrder);
            //update usingProject
            if (!usingProjects.includes(projectInuseId)) {
                usingProjects.push(projectInuseId);
            }
            form.usingProjects = usingProjects;
        } else {
            //remove form order
            if (formOrder.hasOwnProperty(projectInuseId)) {
                delete formOrder[projectInuseId];
                form.order = JSON.stringify(formOrder);
            }
            //update usingProject
            if (usingProjects.includes(projectInuseId)) {
                let indexOfProject = usingProjects.indexOf(projectInuseId);
                if (indexOfProject > -1) {
                    usingProjects.splice(indexOfProject, 1);
                }
                form.usingProjects = usingProjects;
            }
        }
        if(!form?.usingProjects.includes(projectInuseId) && originForm?.usingProjects?.includes(projectInuseId) && originForm?.isUsingInCategories){
            isHasFormUsingCategory = true;
            listFormCannotInactive.push(form)
        }else{
            listFormUpdate.push(form);
        }

    }

    if (isHasFormUsingCategory) {
        argsAll?.setListFormCannotInactive([...listFormCannotInactive])
        argsAll.setListFormUpdate([...listFormUpdate]);
        argsAll.setIsOpenConfirmInActiveForm(true);
        argsAll.setIsLoading(false);
        return {isOpenConfirmInactiveForm :true}
    }

    await Promise.all(listFormUpdate?.map( async (form) => {
        let updateFormData = {
            usingProjects: form.usingProjects,
            order: form.order,
            currentProjectId: form.isProjectInuse ? projectInuseId : null
        };
        await updateFormsData(argsAll.API, form.id, updateFormData);

            //update listForm
        let indexForm = listFormClone.findIndex((x) => x.id === form.id);
        if (indexForm !== -1) {
            listFormClone[indexForm] = form;
        }
    }))


    argsAll.setIsLoading(false);
    argsAll.setListForm(listFormClone);
    argsAll.setIsChangeData(false);

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
};


export const confirmSubmitListForm = async (argsAll,listFormUpdate) => {
    if(Utils.isEmptyArray(listFormUpdate)){
        return
    }
    argsAll.setIsLoading(true);
    let projectInuseId = argsAll.projectInuseDetail.id;
    let listFormClone = [...argsAll.listForm];
    await Promise.all(listFormUpdate?.map( async (form) => {
        let updateFormData = {
            usingProjects: form.usingProjects,
            order: form.order,
            currentProjectId: form.isProjectInuse ? projectInuseId : null
        };
        await updateFormsData(argsAll.API, form.id,updateFormData);

        //update listForm
        let indexForm = listFormClone.findIndex((x) => x.id === form.id);
        if (indexForm !== -1) {
            listFormClone[indexForm] = form;
        }
    }))

    argsAll.setIsLoading(false);
    argsAll.setListForm(listFormClone);
    argsAll.setIsChangeData(false);

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

} 

/**Handler logic FormList - end*/

export const getListFormByCorporation = async (API, corporationId, projectInuseDetail) => {
    let projectInuseId = projectInuseDetail?.id;
    let listForm = await getFormListByCorporation(API, corporationId, {from :0, size: 300, isGetForList: true });

    for (let form of listForm) {
     
        form.isProjectInuse = form.usingProjects.includes(projectInuseId)

        if (form.usingTickets) {
            const usingTickets = JSON.parse(form.usingTickets);
            form.isInuse = Utils.isEmptyObject(usingTickets) ? false : true
        } else {
            form.isInuse = false
        }

        if (form.definition === Constant.FORM_DEFINITION.SYSTEM) {
            form.definitionName = Constant.FORM_DEFINITION_NAME.SYSTEM;
        } else if (form.definition === Constant.FORM_DEFINITION.SAMPLE) {
            form.definitionName = Constant.FORM_DEFINITION_NAME.SAMPLE;
        } else {
            if (!Utils.isEmpty(projectInuseDetail)) {
                form.definitionName = Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    projectInuseDetail.name
                );
            } else {
                form.definitionName = '';
            }
        }
    }

    return listForm;
};

export const getListFieldInProject = async (argsAll) => {
    let systemFieldList = [];

    let listFieldProject = [...argsAll.fieldListInState];

    if (!Utils.isEmptyArray(listFieldProject) && argsAll?.projectInuseId) {
        listFieldProject = listFieldProject.filter(item => {
            const HIDDEN_FROM_FORM_FIELDS = [
                Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
                ...TELEPHONE_FIELDS,
                ...AI_TELEPHONE_SYSTEM_FIELDS,
                ...KB_KNOWLEDGE_FIELDS
            ];
            return (
                item.usingProjects.includes(argsAll.projectInuseId) &&
                ![...TmpHiddenSystemField, ...AISystemField, ...HIDDEN_FROM_FORM_FIELDS].includes(
                    item.sysField
                )
            );
        });
    }
   

    // let indexField = listFieldProject.length;
    // argsAll.setIndexField(indexField);

    listFieldProject = sortFieldListByOrder(listFieldProject, argsAll.projectDetail);

    let listFieldResult = systemFieldList.concat(listFieldProject);
   

    
    let listFieldResultClone = cloneDeep(listFieldResult);
    listFieldResultClone.forEach((field) => {
        field.isUsingForm = false;
    })

    

    return listFieldResult;
};

export const onBeforeDragStartHandler = (event, args) => {

    //disable slide before drag start
    // let newSetting = { ...args.settingSlideRecoilState };
    // newSetting.disable = true;

    //args.setSettingSlideRecoilState(newSetting);
    args.setIsChangeData(true);
};

const sortFieldAddToForm = (listFieldAddToForm,formDetail) => {
    let newListFieldAddToForm = [];
    let fieldInActive = [];

    listFieldAddToForm.forEach((field) =>{
        if (field?.usingProjects?.includes(formDetail?.affiliationProject)) {
            newListFieldAddToForm.push(field)
        }else{
            fieldInActive.push(field)
        }
    })
    return [...newListFieldAddToForm,...fieldInActive]
}

export const onDragEndHandler = (result, args) => {
    if (!result.destination) return;
    let startIndex = result.source.index;
    let endIndex = result.destination.index;
    if(startIndex === endIndex) return;
    let listFieldAddToForm = [...args.listFieldAddToForm];
    const draggableId = result.draggableId
    if(draggableId?.includes('dummy_')){
       let dragField = listFieldAddToForm.find(field => field.id === draggableId);

       if(Utils.isEmptyObject(dragField)){
            dragField = args.fieldAddList?.find(field => field.id === draggableId);
            if(!Utils.isEmptyObject(dragField)){
                listFieldAddToForm.splice(startIndex, 0, dragField);
           }
       }
    }
    listFieldAddToForm = sortFieldAddToForm(listFieldAddToForm,args.formEdit)
    let [removed] = listFieldAddToForm.splice(startIndex, 1);
    listFieldAddToForm.splice(endIndex, 0, removed);
    listFieldAddToForm = listFieldAddToForm?.filter(field => !Utils.isEmptyObject(field))
    args.setListFieldAddToForm(listFieldAddToForm);

    //enable slide and set current start index
    let newSetting;
    newSetting = { ...args.settingSlideRecoilState };
    newSetting.disable = false;
    args.setSettingSlideRecoilState(newSetting);
}

export const onChangeItemInForm = (args, field, regionDropId) => {
    if (!field) return;
    let fieldClone = cloneDeep(field);

    if (regionDropId === 'listFieldAddToForm') {
        fieldClone.isUsingForm = false;
        
        args.setListFieldAddToForm(listFieldAddToForm => {
            let index = listFieldAddToForm.findIndex(x => x.id === fieldClone.id);
            listFieldAddToForm.splice(index, 1);
            return listFieldAddToForm;
        });

        args.setListFieldInProject(prevFieldListInProject => {
            let listFieldInProject = [...prevFieldListInProject, fieldClone]

            let listSystemField = listFieldInProject.filter(x => x.definition === Constant.FORM_DEFINITION.SYSTEM);
            let listCustomField = listFieldInProject.filter(x => [Constant.FORM_DEFINITION.USER, Constant.FORM_DEFINITION.MASTER, Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD].includes(x.definition));
            listCustomField = sortFieldListByOrder(listCustomField, args.projectDetail);

            listFieldInProject = listSystemField.concat(listCustomField);
            return listFieldInProject;
        })

    } else if (regionDropId === 'listFieldInProject') {
        fieldClone.isUsingForm = true;
        args.setListFieldInProject(listFieldInProject => {
            let index = listFieldInProject.findIndex(x => x.id === fieldClone.id);
            listFieldInProject.splice(index, 1);
            return listFieldInProject;
        });

        args.setListFieldAddToForm(listFieldAddToForm => {
            let listFieldAddToFormClone = [...listFieldAddToForm, fieldClone]
            return listFieldAddToFormClone;
        });
    }

    args.setIsChangeData(true);
}

/**
 * Update list field add to form
 * @param {*} argsCommon
 */
export const updatelistFieldAddToForm = (argsCommon) => {
    if (Utils.isEmptyArray(argsCommon.fieldList)) {
        return;
    }

    // flag update
    let isUpdate = false;

    let fieldListForUpdate = [...argsCommon.listFieldAddToForm];
    argsCommon.fieldList.forEach((field) => {
        let index = Utils.findIndexInArrayById(field.id, fieldListForUpdate);
        if (index === -1) {
            fieldListForUpdate = [field].concat(fieldListForUpdate);
            isUpdate = true;
        }
    });

    if (isUpdate) {
        argsCommon.setListFieldAddToForm(fieldListForUpdate);
    }
};

/**
 * Validate add field input
 * @param {*} argsCommon
 * @returns isValidateError
 */
export const validateErorAddFieldInput = (argsCommon) => {
    // validate field list
    let fieldList = [...argsCommon.listFieldAddToForm];
    if(!Utils.isEmptyArray(argsCommon.fieldAddList)) {
          
    }
    let isValidateError = false;
    let fieldListValidateResult = validateFieldList(fieldList, isValidateError);
    isValidateError = fieldListValidateResult.isValidateError;
    fieldList = fieldListValidateResult.fieldList;
    if (isValidateError) {
        argsCommon.setListFieldAddToForm(fieldList);
    }

    // validate add field list
    if(!Utils.isEmptyArray(argsCommon.fieldAddList)) {
        let fieldAddList = [...argsCommon.fieldAddList];
        let fieldAddListValidateResult = validateFieldList(fieldAddList, isValidateError);
        isValidateError = fieldAddListValidateResult.isValidateError;
        argsCommon.setFieldAddList(fieldAddListValidateResult.fieldList);
    }
    

    argsCommon.setIsLoading(true);

    return isValidateError;
};

export const validateShareRangeAddFieldToForm = (args, fieldListInForm, formShareRange, shareOption) => {
    let result = [];
    for (let i = 0; i < fieldListInForm.length; i++) {
        let field = fieldListInForm[i];
        // todo: cần check field có quyền edit hay không (field được share từ prj khác trong org hoặc field được share từ org khác)
        if (hasPermissionUpdate(field, args.projectInuseId) === false) {
            continue;
        }
        let fieldName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name);

        let fieldIsSettingGlobal = false;
        if (field.newUsage && field.newUsage === Constant.FORM_USAGE.FIELD_GLOBAL) {
            fieldIsSettingGlobal = true;
        } else {
            if (field.usage === Constant.FORM_USAGE.FIELD_GLOBAL) {
                fieldIsSettingGlobal = true;
            }
        }
        let shareOptionField = field?.newShareOption ? field.newShareOption : field?.shareOption;
        if (shareOption === Constant.SHARE_OPTION.ALL_ORG && fieldIsSettingGlobal === false) {
            result.push(fieldName);
        } else if (shareForOrgOption.includes(shareOption)) {
            // check trường hợp form có share cho org

            // nếu field hiện tại đã hoặc share global => bỏ qua
            if (fieldIsSettingGlobal === true) {
                continue;
            }

            // if (!shareOptionField || shareOptionField !== Constant.SHARE_OPTION.SPECIFIC_ORG) {
            //     result.push(fieldName);
            // }
            if (!shareOptionField) {
                result.push(fieldName);
            }

            let shareRangeField = field?.newShareRange ? field.newShareRange : field.shareRange;
            if (!shareRangeField || shareRangeField.length <= 0) {
                result.push(fieldName);
                continue;
            }
            // compare field and form share range
            let difference = formShareRange.filter(x => !shareRangeField.includes(x));
            if (difference.length > 0) {
                result.push(fieldName)
            } 
        }
    }

    if (result.length > 0) {
        result = [...new Set(result)];
        let fieldNames = result.map(name => `「${name}」`);
        fieldNames = fieldNames.join('、')
        const message = `フィールド ${fieldNames} は外部に共有されていません。フィールドの共有範囲を変更して宜しいでしょうか？`;
        return message;
    }

    return false;
};

export const hasPermissionUpdate = (field, projectInuseId) => {
    if (field.definition === Constant.FORM_DEFINITION.SYSTEM || 
        field.affiliationProject !== projectInuseId ||
        field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
    ) {
        return false;
    }
    return true;
};

/**
 * Validate error add field to form
 * @param {*} argsCommon 
 * @param {*} fieldListInForm 
 * @returns isValidateError
 */
export const validateErrorAddFieldToForm = (argsCommon, fieldListInForm) => {
    if (!Utils.isEmptyArray(fieldListInForm)) {
        return false;
    }
    let isError = true;
    argsCommon.fieldAddList.forEach(field => {
        if (field.addToForm) {
            isError = false;
            return;
        }
    });
    return isError;
};

export const updateShareFormToField = (args) => {
    let shareOption = args.shareOptionValue;
    let shareDestination = args.shareDestination;
    let listFieldAddToForm = cloneDeep(args.listFieldAddToForm);
    let newShareRange = [];
    shareDestination.map(item => newShareRange.push(item.id))
    // let newFieldAddToForm = [];
    listFieldAddToForm.map(fieldAdd => {
        // check field not system field
        if (hasPermissionUpdate(fieldAdd, args.projectInuseId)) {
            let oldShareRange = fieldAdd.shareRange ? fieldAdd.shareRange : [];
            fieldAdd.shareRange = oldShareRange;

            fieldAdd.shareOption = fieldAdd?.shareOption ? fieldAdd.shareOption : 1
            fieldAdd.newUsage = shareOption === Constant.SHARE_OPTION.ALL_ORG ? Constant.FORM_USAGE.FIELD_GLOBAL : Constant.FORM_USAGE.FIELD ;
            fieldAdd.newShareOption = newShareRange.length > 0 ? Constant.SHARE_OPTION.SPECIFIC_ORG : shareOption;
            fieldAdd.newShareRange = [...oldShareRange, ...newShareRange];
        }
        // newFieldAddToForm.push(fieldAdd);
        return fieldAdd
    })
    args.setListFieldAddToForm(listFieldAddToForm);
    args.listFieldAddToForm = listFieldAddToForm;
 
    if (!Utils.isEmptyArray(args.fieldAddList)) {
        let fieldAddList = cloneDeep(args.fieldAddList);
        // let newFieldAddList = [];
        fieldAddList.forEach(fieldAdd => {
            if ((Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm) === -1 || (args.isDuplicateForm && args.formEdit?.isShared)) &&
                (fieldAdd.clientFieldType === Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD || fieldAdd.clientFieldType === Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD)) {
                
                if (hasPermissionUpdate(fieldAdd, args.projectInuseId)) {
                    fieldAdd.shareOption = shareOption
                    fieldAdd.usage = shareOption === Constant.SHARE_OPTION.ALL_ORG ? Constant.FORM_USAGE.FIELD_GLOBAL : Constant.FORM_USAGE.FIELD ;
                    fieldAdd.shareRange = newShareRange; 
                    // let oldShareRange = fieldAdd?.shareRange ? fieldAdd.shareRange : [];

                    // fieldAdd.shareOption = fieldAdd?.shareOption ? fieldAdd.shareOption : 1
                    // fieldAdd.shareRange = oldShareRange;
                    
                    // fieldAdd.newUsage = shareOption === Constant.SHARE_OPTION.ALL_ORG ? Constant.FORM_USAGE.FIELD_GLOBAL : Constant.FORM_USAGE.FIELD ;
                    // fieldAdd.newShareOption = newShareRange.length > 0 ? Constant.SHARE_OPTION.SPECIFIC_ORG : shareOption;
                    // fieldAdd.newShareRange = [...oldShareRange, ...newShareRange];
                }
                // newFieldAddList.push(fieldAdd);
            }
        })
        args.setFieldAddList(fieldAddList);
        args.fieldAddList = fieldAddList;
    }
}

const getOptionValueOfCreateTicketForOwnerBasePermission = listSelectedOption => {

    const listValueOption = Object.keys(
        Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT
    )?.filter(key => {
        return listSelectedOption?.includes(
            Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT[key]
        );
    });

    return listValueOption;
};

export const prepareParamsSubmitAddField = argsCommon => {
    let fieldListInState = [...argsCommon.fieldListInState];
    
    // reset field type
    argsCommon.setFieldTypeSelectedList([]);

    let indexField = Math.max.apply(
        Math,
        fieldListInState.map(field => {
            let orderObj = field.order;
            let order =
                orderObj && orderObj[argsCommon.projectInuseId]
                    ? orderObj[argsCommon.projectInuseId]
                    : 0;
            return order;
        })
    );

    let fieldOrder = indexField + 1;
    argsCommon.fieldAddList.forEach(field => {
        field.order = { [`${argsCommon.projectInuseId}`]: fieldOrder };
        fieldOrder++;
    });

    let arrParamsNewField = [];

    // update field list
    argsCommon.fieldAddList.map(async field => {
        // edit field
        if (!isAddNewField(field)) {
            return field;
        }

        // add field
        // convert inputData to requestData
        let requestField = { ...field };

        delete requestField.isErrorValidate;
        delete requestField.isShowInfo;
        delete requestField.clientFieldType;
        delete requestField.itemList;
        delete requestField.isProjectInuse;
        delete requestField.defaultItemList;
        delete requestField.required;
        delete requestField.publicForCustomer;
        delete requestField.errors;
        delete requestField.isUsingForm;
        delete requestField.structure.isSaveItemList;
        delete requestField.createdAt;
        delete requestField.updatedAt;
        delete requestField.hasValue;
        delete requestField.usingForms;
        delete requestField.usingTickets;
        delete requestField.sharedFormList;
        delete requestField.sharedFieldList;
        delete requestField.newUsage;
        delete requestField.newShareOption;
        delete requestField.newShareRange;
        delete requestField?.isUsingInCategories;
        delete requestField?.formCategories;

        delete requestField?.indexInList
        delete requestField?.__typename
        delete requestField?.usingTicket
        delete requestField?.usedProject
        delete requestField?.isAllowCustomerChangeStatus
        delete requestField?.hideInProject

        requestField.name = JSON.stringify(requestField.name);
        requestField.structure = JSON.stringify(requestField.structure);
        requestField.explanation = JSON.stringify(requestField.explanation);
        requestField.order = JSON.stringify(requestField.order);
        requestField.viewForCustomer =
            typeof requestField.viewForCustomer === 'object'
                ? JSON.stringify(requestField.viewForCustomer)
                : requestField.viewForCustomer;
        requestField.usingProjects = [argsCommon.projectDetail.id];

        let requestItemList = [];
        // create tag field item
        if (
            field.structure.UI === Constant.FIELD_UI.TAG &&
            field.structure.settingSelectItem !==
                Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE
        ) {
            requestItemList = buildCreateItemTagRequest(field, field.itemList);
        }

        // create status field item
        if (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW) {
            requestItemList = buildCreateItemStatusRequest(field, field.itemList);
        }

        switch (field.structure.settingSelectItem) {
            // master knowledge
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.MASTER_KNOWLEDGE:
                let masterKnowledge = field.masterKnowledge;
                let structure = JSON.parse(requestField.structure);

                // structure.formMaster = masterKnowledge.formMaster;
                // structure.isAutoAddData = masterKnowledge.isAutoAddData;

                requestField.relatedMasterForm = masterKnowledge?.formMaster;
                requestField.settingAutoAdd = masterKnowledge?.isAutoAddData;

                structure.listItem = masterKnowledge?.listItem;

                delete requestField.masterKnowledge;
                requestField.structure = JSON.stringify(structure);

                requestField.definition = Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD;
                break;
            case Constant.SETTING_SELECT_ITEM_TAG_FIELD.AUTO_FILL:
                if(!field.autoFillMasterField) {
                    break;
                }
                let autoFillMasterField = field.autoFillMasterField;
                let autoFillStructure = JSON.parse(requestField.structure);

                requestField.relatedMasterForm = autoFillMasterField.formMaster;
                requestField.settingAutoAdd = autoFillMasterField.isAutoAddData;
                autoFillStructure.listItem = autoFillMasterField.listItem;
                delete requestField.autoFillMasterField;
                requestField.structure = JSON.stringify(autoFillStructure);
                requestField.definition = Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD;
                break;
            default:
                break;
        }

        arrParamsNewField.push({ field: requestField, itemList: requestItemList });
    });

    return arrParamsNewField;
};

/**
 * Handler submit add form
 * @param {*} data 
 * @param {*} args 
 * @returns fieldList
 */
export const onSubmitAddForm = async (data, args, isSynonym) => {
    args.setIsLoading(false);
    let shareOption = args.shareOptionValue;
    let shareDestination = args.shareDestination;

    const viewPermissionsList = args.selectedViewPermissions;
    let viewPermission = [];
    const knowledgeTicketViewPermissions = Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT;
    viewPermission = Object.keys(knowledgeTicketViewPermissions).filter(key => 
        viewPermissionsList.includes(knowledgeTicketViewPermissions[key])
    )

    const editPermissionList = args.selectedEditPermissions;
    let editPermission = [];
    const knowledgeTicketEditPermissions = Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT;
    editPermission = Object.keys(knowledgeTicketEditPermissions).filter(key => 
        editPermissionList.includes(knowledgeTicketEditPermissions[key])
    )

    const knowledgeTicketChatPermissions = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT;
    let chatPermission = Object.keys(knowledgeTicketChatPermissions).find(key => 
        knowledgeTicketChatPermissions[key] === args.selectedChatPermissions
    )
   
    let createTicketForOwnerPermission = []
    createTicketForOwnerPermission = getOptionValueOfCreateTicketForOwnerBasePermission(args?.createTicketForOwnerBasePermission);

    let additionalCreateTicketForOwnerPermission = []
    additionalCreateTicketForOwnerPermission = args?.additionalCreateTicketForOwnerPermission?.map(option => option.id);

    if (Utils.isEmptyString(data.name) || Utils.isEmptyString(args.addFormType)) {
        args.setIsLoading(false);
        return;
    }

    

    let listFieldAddToForm = cloneDeep(args.listFieldAddToForm);
    if (!Utils.isEmptyArray(args.fieldAddList)) {
        args.fieldAddList.forEach(fieldAdd => {
            if (Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm) === -1 &&
                (fieldAdd.clientFieldType === Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD || fieldAdd.clientFieldType === Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD)) {
                listFieldAddToForm.push(fieldAdd);
            };

            if((Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm) === 0 || Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm)) && fieldAdd?.id?.includes('dummy')){
                let indexFiled = Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm);
                listFieldAddToForm[indexFiled] = fieldAdd
            };
        })
    }

    

    if (validateErorAddFieldInput(args) || validateErrorAddFieldToForm(args, listFieldAddToForm)) {
        args.setIsLoading(false);
        return;
    }

    let usage = Constant.FORM_USAGE.FORM;
    let shareRange = [];
    
    // namnh todo: hard fix
    if (shareOption === Constant.SHARE_OPTION.ALL_ORG) {
        usage = Constant.FORM_USAGE.FORM_GLOBAL;
        let validateResult = validateShareRangeAddFieldToForm(args, listFieldAddToForm, shareRange, shareOption);
        if (validateResult) {
            args.setIsLoading(false);
            return args.setConfirmDialogObj({open: true, msg: validateResult, action: 'add'});
        }
    } 

    shareDestination.map(item => shareRange.push(item.id))
    if (shareForOrgOption.includes(shareOption)) {
        if (shareDestination.length <= 0) {
            args.setIsLoading(false);
            return;
        }
        if (shareRange && shareRange.length > 0) {
            let validateResult = validateShareRangeAddFieldToForm(args, listFieldAddToForm, shareRange, shareOption);

            if (validateResult) {
                args.setIsLoading(false);
                return args.setConfirmDialogObj({open: true, msg: validateResult, action: 'add'});
            }
        }
    }

    let prepareParamsAddField = []

    // validate
    if (!Utils.isEmptyArray(args.fieldAddList)) {
        prepareParamsAddField = prepareParamsSubmitAddField(args);
    }

    

    // if validate true then add field
    // call api submit field

    if (Utils.isEmptyArray(listFieldAddToForm)) {
        args.setIsLoading(false);
        return;
    }

    // Generate formStructure
    let settingTitle = cloneDeep(args.settingTitle);
    let titleLineNumber = args.titleLineNumber;
    let splitPdf = args.splitPdf;

    //Generate order form
    let newOrder = generateOrderForNewForm(args.listForm, args.addFormType, args.projectInuseId);

    let formType = args.addFormType;
    let reviewFlag;
    if(args.addFormType === Constant.FORM_TYPE.FORM_KNOWLEDGE && args.settingMasterKnowledge === 1){
        formType = Constant.FORM_TYPE.FORM_MASTER
    }
    if (args.addFormType === Constant.FORM_TYPE.FORM_KNOWLEDGE && args.settingReviewFlag) {
        reviewFlag = true;
    }

    const formData = {
        usage: usage,
        name: JSON.stringify({
            jp: {
                A: 'F',
                text: data.name,
            },
        }),
        affiliationOrganization: args.corporationId,
        affiliationProject: args.projectInuseId,
        affiliationField: '',
        creator: args.userId,
        updator: args.userId,
        type: formType,
        reviewFlag,
        viewForCustomer: JSON.stringify({}),
        definition: Constant.FORM_DEFINITION.USER,
        explanation: JSON.stringify({}),
        usingProjects: [args.projectInuseId],
        usingTickets: JSON.stringify({}),
        order: JSON.stringify({
            [args.projectInuseId]: newOrder
        }),
        shareRange: shareRange,
        shareOption: shareOption,

        viewPermission,
        editPermission,
        chatPermission,
        createTicketForOwnerPermission,
        additionalCreateTicketForOwnerPermission,
        isSynonym: isSynonym ? true: false,
        // CR-2026-006: attachment auto-translation config (stored on Form schema fields)
        autoTranslateAttachment: args.autoTranslateAttachment ? true : false,
        translateSourceLang: args.translateSourceLang || '',
        translateTargetLangs: !Utils.isEmptyArray(args.translateTargetLangs) ? args.translateTargetLangs : []
    };

    // let createFormResult = await createFormsData(args.API, formData);
    // create form with api create new field
    let formCreateParams = [
        {
            field: formData,
            itemList: []
        }
    ];

    let requestData = {
        fieldList: prepareParamsAddField,
        listFieldAddToForm: JSON.stringify(listFieldAddToForm),
        projectInuseId: args.projectInuseId,
        userId: args.userId,
        formCreateParams: formCreateParams,
        settingTitle: JSON.stringify(settingTitle),
        titleLineNumber: titleLineNumber,
        corporationId: args.corporationId,
        method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.CREATE_NEW_FORM,
        splitPdf
    }
    if (formType === Constant.FORM_TYPE.FORM_REQ_QA) {
        requestData.isAllowCustomerChangeStatus = args?.isAllowCustomerChangeStatus
    }

    const result = await updateFormField(args.API, requestData);


    let {
        listFieldAddToFormResponse,
        listFieldUpdateSharePermission,
        fieldDataAddNew,
        createFormResult
    } = result;
    fieldDataAddNew = Utils.convertJSONDataToObject(fieldDataAddNew);
    listFieldAddToFormResponse = Utils.convertJSONDataToObject(listFieldAddToFormResponse);
    createFormResult = Utils.convertJSONDataToObject(createFormResult);
    listFieldUpdateSharePermission = Utils.convertJSONDataToObject(listFieldUpdateSharePermission);

    args.setFieldList([]);
    args.setListFieldAddToForm(listFieldAddToFormResponse);


    let fieldListInState = [...args.fieldListInState];
    
    if(!Utils.isEmptyArray(fieldDataAddNew)) {
        fieldListInState = [...fieldDataAddNew, ...fieldListInState];
    }

    if(!Utils.isEmptyArray(listFieldUpdateSharePermission)) {
        fieldListInState.forEach(item => {
            let index = Utils.findIndexInArrayById(item.id, listFieldUpdateSharePermission);
            if(index !== -1) {
                if (item.id === listFieldUpdateSharePermission[index].id) {
                    item.usage = listFieldUpdateSharePermission[index].usage
                    item.shareOption = listFieldUpdateSharePermission[index].shareOption
                    item.shareRange = listFieldUpdateSharePermission[index].shareRange;
                    item.usingForms = JSON.parse(listFieldUpdateSharePermission[index].usingForms);
                }
            }
        })
    }

    let listCustomFieldAddToForm = listFieldAddToFormResponse.filter(field =>
        [Constant.FORM_DEFINITION.USER, Constant.FORM_DEFINITION.MASTER].includes(field.definition)
    );

    const formId = createFormResult?.id;
    let fieldListInStateClone = cloneDeep(fieldListInState)
    listCustomFieldAddToForm.forEach((field) => {
        let usingForms = !Utils.isEmptyObject(field.usingForms) ? field.usingForms : {};
        usingForms[formId] = {
            active: Constant.FIELD_USING_FORMS.ACTIVE,
            hasValue: Constant.FIELD_USING_FORMS.NO_VALUE
        }

        let index = Utils.findIndexInArrayById(field.id, fieldListInState);
        if (index >= 0) {
            fieldListInStateClone[index].usingForms = usingForms;
        }
    })

    args.setFieldListInState(fieldListInStateClone);
    let newFormList = await getListFormByCorporation(args.API, args.corporationId, args.projectInuseDetail);
    args.setFormList(newFormList);
    args.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
    args.setIsLoading(false);
    args.enqueueSnackbar(buildSnackbarMessage('FIELDFORMMSG002'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    
};

const generateOrderForNewForm = (listForm, addFormType, projectInuseId) => {
    let newOrder;
    if (!Utils.isEmptyArray(listForm)) {
        let listFormByType = filterListFormByFormType(listForm, addFormType, projectInuseId);
        let listFormActive = listFormByType.filter(form => form.isProjectInuse)

        if (!Utils.isEmptyArray(listFormActive)) {
            let currentMaxOrder = Math.max.apply(Math, listFormActive.map((form) => {
                let orderObj = JSON.parse(form.order);
                let order = orderObj[projectInuseId];
                return order;
            }))
            newOrder = currentMaxOrder + 1;
        }
        else {
            newOrder = 1;
        }
    } else {
        newOrder = 1;
    }

    return newOrder;
}

export const getListFieldCanAddToForm = (argsAll, fieldInForm) => {
    let systemFieldList = [];

    // if (!Utils.isEmptyArray(systemField)) {
    //     for (const field of systemField) {
    //         if (
    //             field.usage === Constant.FORM_USAGE.FIELD &&
    //             ((argsAll.isUsingSystemFormInvite && field.noInFormInvite) ||
    //                 (argsAll.isUsingSystemFormQA && field.noInFormQA))
    //         ) {
    //             systemFieldList.push(field);
    //         }
    //     }
    // }

    let listFieldProject = [...argsAll.fieldListInState];
    // let indexField = listFieldProject.length;
    // argsAll.setIndexField(indexField);

    if (!Utils.isEmptyArray(listFieldProject)) {
        listFieldProject = listFieldProject.filter((item) => {
            if(Utils.isEmptyArray(item.usingProjects)) {
            }
            const HIDDEN_FROM_FORM_FIELDS = [
                Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING,
                ...TELEPHONE_FIELDS,
            ];
            return item.usingProjects?.includes(argsAll.projectInuseId) && ![...TmpHiddenSystemField, ...AISystemField, ...HIDDEN_FROM_FORM_FIELDS].includes(item.sysField);
        });
    }
    listFieldProject = systemFieldList.concat(listFieldProject);

    let listFieldCanAddToForm = listFieldProject.filter(x => !fieldInForm.find(z => z.id === x.id));
    let listFieldResultClone = cloneDeep(listFieldCanAddToForm);
    listFieldResultClone.forEach((field) => {
        field.isUsingForm = false;
    })

    return listFieldResultClone;
};

export const getFormFieldData = (formStructure, fieldList) => {
    let fieldListClone = cloneDeep(fieldList);
    let formData = [];

    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                let fieldData = {};
                let fieldId = '';

                let formField = formStructure[fieldNumber];

                if (
                    formStructure[fieldNumber].hasOwnProperty('field') &&
                    !Utils.isEmptyArray(fieldListClone)
                ) {
                    fieldId = formStructure[fieldNumber]['field'];
                    fieldData = fieldListClone.find((customField) => customField.id === fieldId);
                } else if (
                    formStructure[fieldNumber].hasOwnProperty('sysfield') &&
                    !Utils.isEmptyArray(systemField)
                ) {
                    fieldId = formStructure[fieldNumber]['sysfield'];
                    fieldData = systemField.find((sysField) => sysField.id === fieldId);
                }

                if (!Utils.isEmptyObject(fieldData)) {
                    fieldData.required = formField.required;
                    fieldData.publicForCustomer = formField.publicForCustomer;
                    formData.push(fieldData);
                }
            }
        }
    }

    let fieldListInForm = Utils.sortByCreatedAtAsc(formData);

    return fieldListInForm;
};

export const getListFieldInForm = (formStructure, fieldList) => {
    let fieldListClone = cloneDeep(fieldList);
    let formData = [];

    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                let fieldData = {};
                let fieldId = '';

                let formField = formStructure[fieldNumber];

                if (
                    formStructure[fieldNumber]?.hasOwnProperty('field') &&
                    !Utils.isEmptyArray(fieldListClone)
                ) {
                    fieldId = formStructure[fieldNumber]['field'];
                    fieldData = fieldListClone.find((customField) => customField.id === fieldId);
                } else if (
                    formStructure[fieldNumber]?.hasOwnProperty('sysfield') &&
                    !Utils.isEmptyArray(systemField)
                ) {
                    // fieldId = formStructure[fieldNumber]['sysfield'];
                    // fieldData = systemField.find((sysField) => sysField.id === fieldId);
                }

                if (!Utils.isEmptyObject(fieldData)) {
                    fieldData.required = formField.required;
                    fieldData.publicForCustomer = formField.publicForCustomer;
                    formData.push(fieldData);
                }
            }
        }
    }

    return formData;
};

export const updateListFieldBeforeEditForm = (args, listCustomFieldAddToForm, listCustomFieldInProject, fieldListInState) => {
    let formId = args.formEdit.id;
    let fieldListInStateClone = fieldListInState ? cloneDeep(fieldListInState) : cloneDeep(args.fieldListInState);

    //update list field add to form
    listCustomFieldAddToForm.forEach((field) => {
        let usingForms = !Utils.isEmptyObject(field.usingForms) ? cloneDeep(field.usingForms) : {};
        usingForms = Utils.convertJSONDataToObject(usingForms)
        usingForms[formId] = {
            active: Constant.FIELD_USING_FORMS.ACTIVE,
            hasValue: usingForms[formId]?.hasValue ? usingForms[formId]?.hasValue : Constant.FIELD_USING_FORMS.NO_VALUE
        }
        let index = Utils.findIndexInArrayById(field.id, fieldListInStateClone);
        if (index >= 0) {
            fieldListInStateClone[index].usingForms = usingForms;
        }
    });
    //update list field remove form Form
    listCustomFieldInProject.forEach((field) => {
        let usingForms = !Utils.isEmptyObject(field.usingForms) ? cloneDeep(field.usingForms) : {};

        if (!Utils.isEmptyObject(usingForms) && usingForms.hasOwnProperty(formId)) {
            usingForms[formId].active = Constant.FIELD_USING_FORMS.INACTIVE;
            let index = Utils.findIndexInArrayById(field.id, fieldListInStateClone);
            if (index >= 0) {
                fieldListInStateClone[index].usingForms = usingForms;
            }
        }
    });
    args.setFieldListInState(fieldListInStateClone);
}

export const validateShareFormDuplicate = async args => {
    let formData = args.formEdit;
    let listForm = await getFormListByCorporation(args.API, args.corporationDetail?.id,{from :0, size: 300, isGetForList: true }, []);

    if (Utils.isEmptyArray(listForm)) return false;

    if (listForm.findIndex(form => form.id === formData?.id) === -1) return false;

    return true;
};

export const onSubmitEditForm = async (formName, formType, args, isSynonym) => {
    args.setIsLoading(true);
    if (args.isDuplicateForm) {
        let isFormShared = await validateShareFormDuplicate(args);
        if(!isFormShared) {
            args.setIsOpenModalReloadPage(true);
            args.setIsLoading(false);
            return;
        }
    }
    
    const latestCurrentForm = await getFormById(args.API, args.formEdit.id);
    if ((latestCurrentForm.reviewFlag && !args.formEdit.reviewFlag) || (!latestCurrentForm.reviewFlag && args.formEdit.reviewFlag)) {
        args.setIsLoading(false);
        args.setIsOpenModalReloadPage(true);
        return;
    }

    if (Utils.isEmptyString(formName) || Utils.isEmptyString(formType)) {
        args.setIsLoading(false);
        return;
    }

    let listFieldAddToForm = cloneDeep(args.listFieldAddToForm);
    let listFieldInProject = cloneDeep(args.listFieldInProject);

    if (!Utils.isEmptyArray(args.fieldAddList)) {
        args.fieldAddList.forEach(fieldAdd => {
            if (Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm) === -1 &&
                (fieldAdd.clientFieldType === Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD || fieldAdd.clientFieldType === Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD)) {
                listFieldAddToForm.push(fieldAdd);
            }

            // if((Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm) === 0 || Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm)) && fieldAdd?.id?.includes('dummy')){
            //     let indexFiled = Utils.findIndexInArrayById(fieldAdd.id, listFieldAddToForm);
            //     listFieldAddToForm[indexFiled] = fieldAdd
            // };
        })
    }

    let isErrorValidateAddFieldInput = validateErorAddFieldInput(args);
    if (isErrorValidateAddFieldInput) {
        args.setIsLoading(false);
        return;
    }

    const knowledgeTicketChatPermissions = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT;
    let chatPermission = Object.keys(knowledgeTicketChatPermissions).find(key => 
        knowledgeTicketChatPermissions[key] === args.selectedChatPermissions);
        
    const editPermissionList = args.selectedEditPermissions;
    let editPermission = [];
    const knowledgeTicketEditPermissions = Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT;
    editPermission = Object.keys(knowledgeTicketEditPermissions).filter(key => 
        editPermissionList.includes(knowledgeTicketEditPermissions[key])
    );
    
    const viewPermissionsList = args.selectedViewPermissions;
    let viewPermission = [];
    const knowledgeTicketViewPermissions = Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT;
    viewPermission = Object.keys(knowledgeTicketViewPermissions).filter(key => 
        viewPermissionsList.includes(knowledgeTicketViewPermissions[key])
    )

    let createTicketForOwnerPermission = []
    createTicketForOwnerPermission = getOptionValueOfCreateTicketForOwnerBasePermission(args?.createTicketForOwnerBasePermission);

    let additionalCreateTicketForOwnerPermission = []
    additionalCreateTicketForOwnerPermission = args?.additionalCreateTicketForOwnerPermission?.map(option => option.id);

    let newUsage = '';
    let newShareOption = args.shareOptionValue;
    let shareDestination = args.shareDestination;
    let newShareRange = [];

  
    if (newShareOption !== Constant.SHARE_OPTION.ALL_ORG && args.formEdit.usage === Constant.FORM_USAGE.FORM_GLOBAL) {
        newUsage = Constant.FORM_USAGE.FORM;
    }

    if (newShareOption === Constant.SHARE_OPTION.ALL_ORG) {
        if (args.formEdit.usage === Constant.FORM_USAGE.FORM) newUsage = Constant.FORM_USAGE.FORM_GLOBAL;
        let validateResult = validateShareRangeAddFieldToForm(args, listFieldAddToForm, newShareRange, newShareOption);
       
        if (validateResult) {
            args.setIsLoading(false);
            return args.setConfirmDialogObj({open: true, msg: validateResult, action: 'edit'});
        }
    } 

   
    shareDestination.map(item => newShareRange.push(item?.id))
    if (shareForOrgOption.includes(newShareOption)) {
        if (shareDestination.length <= 0 && (args.formEdit?.shareRange && args.formEdit.shareRange.length <= 0)) {
            args.setIsLoading(false);
            return;
        }
        if (newShareRange.length > 0) {
            let validateResult = validateShareRangeAddFieldToForm(args, listFieldAddToForm, newShareRange, newShareOption);
           
            if (validateResult) {
                args.setIsLoading(false);
                return args.setConfirmDialogObj({open: true, msg: validateResult, action: 'edit'});
            }
        }
    }

    // handler create field
    let prepareParamsAddField = []

    
    // validate
    if (!Utils.isEmptyArray(args.fieldAddList)) {
        prepareParamsAddField = prepareParamsSubmitAddField(args);
    }

   

    if (validateErrorAddFieldToForm(args, listFieldAddToForm)) {
        args.setIsLoading(false);
        return;
    }
   
    // Generate formStructure
    let settingTitle = cloneDeep(args.settingTitle)
    let fieldListInState = [...args.fieldListInState];
    
    //check case duplicate form
    if (!args.isDuplicateForm) {
        let formUpdateData = {
            // id: args.formEdit.id,
            name: JSON.stringify({
                jp: {
                    A: 'F',
                    text: formName,
                },
            }),
            updator: args.userId,
            shareRange: args.formEdit.shareRange,
            usage: args.formEdit.usage,
            shareOption: args.formEdit.shareOption,
            newShareOption: newShareOption,
            newShareRange: newShareRange,
            newUsage: newUsage,
            affiliationOrganization: args.formEdit.affiliationOrganization,
            affiliationField: args.formEdit.affiliationField,
            affiliationProject: args.formEdit.affiliationProject,
            createdAt: args.formEdit.createdAt,

            chatPermission,
            editPermission,
            viewPermission,
            createTicketForOwnerPermission,
            additionalCreateTicketForOwnerPermission,
            // CR-2026-006: attachment auto-translation config (stored on Form schema fields)
            autoTranslateAttachment: args.autoTranslateAttachment ? true : false,
            translateSourceLang: args.translateSourceLang || '',
            translateTargetLangs: !Utils.isEmptyArray(args.translateTargetLangs) ? args.translateTargetLangs : []
        };

        if ((args.formEdit.type === Constant.FORM_TYPE.FORM_KNOWLEDGE ||args.formEdit.type === Constant.FORM_TYPE.FORM_MASTER)){
            if(args.settingMasterKnowledge === 0){
                formUpdateData.type = Constant.FORM_TYPE.FORM_KNOWLEDGE
            }else{
                formUpdateData.type = Constant.FORM_TYPE.FORM_MASTER
            }

            if (args.settingReviewFlag) {
                formUpdateData.reviewFlag = true;
            } else {
                formUpdateData.reviewFlag = false;
            }

            formUpdateData.isSynonym = isSynonym ? true : false;
        }

        let newParamsAddField = cloneDeep(prepareParamsAddField);
        newParamsAddField = newParamsAddField.map((item) =>{
            let requestField = {...item}
            delete requestField.field?.indexInList;
            delete requestField.field?.__typename;
            delete requestField.field?.usingTicket;
            delete requestField.field?.usedProject;
            delete requestField.field?.isUsingInCategories;
            delete requestField.field?.formCategories;
            delete requestField.field?.isAllowCustomerChangeStatus;
            delete requestField.field?.hideInProject;
            
            return requestField;
        })

        let listFieldIdInProject = listFieldInProject.map(field => field.id); // hotfix for listFieldInProject
        
        let cloneListFieldAddToForm = cloneDeep(listFieldAddToForm);
        cloneListFieldAddToForm = cloneListFieldAddToForm.map((item) =>{
            let requestField = {...item}
            // not use update form
            requestField.itemList = [] 
            requestField.defaultItemList = []
            requestField.usingProjects = [] 
            requestField.order = {} 
            return requestField;
        })
        
        let requestData = {
            fieldList: newParamsAddField,
            listFieldAddToForm: JSON.stringify(cloneListFieldAddToForm), // current field in form
            listFieldInProject: JSON.stringify(listFieldIdInProject), // field id list in project
            projectInuseId: args.projectInuseId,
            formEditId: args.formEdit.id,
            formUpdateData: formUpdateData,
            userId: args.userId,
            settingTitle: JSON.stringify(settingTitle),
            titleLineNumber: args.titleLineNumber,
            splitPdf: args.splitPdf,
            corporationId: args.corporationId,
            method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.EDIT_FORM
        }
        if (args.formEdit.type === Constant.FORM_TYPE.FORM_REQ_QA) {
            requestData.isAllowCustomerChangeStatus = args?.isAllowCustomerChangeStatus
        }

        const result = await updateFormField(args.API, requestData);
        let {
            listFieldAddToFormResponse,
            listFieldUpdateSharePermission,
            fieldDataAddNew,
            updateFormResult
        } = result;

        updateFormResult = Utils.convertJSONDataToObject(updateFormResult);
        fieldDataAddNew = Utils.convertJSONDataToObject(fieldDataAddNew);
        listFieldAddToFormResponse = Utils.convertJSONDataToObject(listFieldAddToFormResponse);
        listFieldUpdateSharePermission = Utils.convertJSONDataToObject(listFieldUpdateSharePermission);
       
        args.setFieldList([]);
        args.setListFieldAddToForm(listFieldAddToFormResponse);

        if(!Utils.isEmptyArray(fieldDataAddNew)) {
            fieldListInState = [...fieldDataAddNew, ...fieldListInState];
        }

        if(!Utils.isEmptyArray(listFieldUpdateSharePermission)) {
            let fieldListInStateClone = []
            fieldListInState.forEach(item => {
                let itemClone = {...item};
                let index = Utils.findIndexInArrayById(item.id, listFieldUpdateSharePermission);
                if(index !== -1) {
                    if (item.id === listFieldUpdateSharePermission[index].id) {
                        itemClone.usage = listFieldUpdateSharePermission[index].usage
                        itemClone.shareOption = listFieldUpdateSharePermission[index].shareOption
                        itemClone.shareRange = listFieldUpdateSharePermission[index].shareRange;
                        itemClone.usingForms = JSON.parse(listFieldUpdateSharePermission[index].usingForms);
                    }
                }
                fieldListInStateClone.push(itemClone)
            })
            fieldListInState = fieldListInStateClone;
        }

        if (!Utils.isEmptyObject(updateFormResult)) {
            //update list fields
            let listCustomFieldAddToForm = listFieldAddToFormResponse.filter(field => [Constant.FORM_DEFINITION.USER, Constant.FORM_DEFINITION.MASTER].includes(field.definition));
            let listCustomFieldInProject = listFieldInProject.filter(field => [Constant.FORM_DEFINITION.USER, Constant.FORM_DEFINITION.MASTER].includes(field.definition));

            //namnh todo update list field shareRange
            updateListFieldBeforeEditForm(args, listCustomFieldAddToForm, listCustomFieldInProject, fieldListInState);

            let listForm = cloneDeep(args.listForm);
            let formIndex = listForm.findIndex(x => x.id === updateFormResult.id);
            listForm[formIndex].shareRange = updateFormResult.shareRange
            listForm[formIndex].usage = updateFormResult.usage
            listForm[formIndex].shareOption = updateFormResult.shareOption
            listForm[formIndex].name = formUpdateData.name;
            listForm[formIndex].structure = updateFormResult.structure;
            listForm[formIndex].isProjectInuse = updateFormResult.usingProjects.includes(args.projectInuseId);
            listForm[formIndex].definitionName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                args.projectDetail.name
            );
            listForm[formIndex].type = updateFormResult.type;
            listForm[formIndex].reviewFlag = updateFormResult.reviewFlag;
            listForm[formIndex].chatPermission = updateFormResult.chatPermission;
            listForm[formIndex].editPermission = updateFormResult.editPermission;
            listForm[formIndex].viewPermission = updateFormResult.viewPermission;

            listForm[formIndex].createTicketForOwnerPermission = updateFormResult.createTicketForOwnerPermission;
            listForm[formIndex].additionalCreateTicketForOwnerPermission = updateFormResult.additionalCreateTicketForOwnerPermission;
            listForm[formIndex].isSynonym = updateFormResult.isSynonym;
            listForm[formIndex].isAllowCustomerChangeStatus = updateFormResult.isAllowCustomerChangeStatus;
            // CR-2026-006: sync attachment auto-translation config back to local state after save
            listForm[formIndex].autoTranslateAttachment = updateFormResult.autoTranslateAttachment;
            listForm[formIndex].translateSourceLang = updateFormResult.translateSourceLang;
            listForm[formIndex].translateTargetLangs = updateFormResult.translateTargetLangs;
            
            args.setListForm(listForm);
            args.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
            args.setIsLoading(false);
            args.enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        } else {
            args.setIsLoading(false);
        }
    } else {
        let objCreateformData = {
            newShareOption: newShareOption,
            newShareRange: newShareRange,
            newUsage: newUsage,

            chatPermission,
            editPermission,
            viewPermission,
            createTicketForOwnerPermission,
            additionalCreateTicketForOwnerPermission: additionalCreateTicketForOwnerPermission
        }

        await duplicateForm(
            formName,
            fieldListInState,
            listFieldAddToForm,
            args,
            objCreateformData,
            prepareParamsAddField,
            settingTitle
        );
    }

};

const duplicateForm = async (
    formName,
    fieldListInState,
    listFieldAddToForm,
    args,
    objCreateformData,
    prepareParamsAddField,
    settingTitle
) => {
    let formOrigin = cloneDeep(args.formEdit);
    //Generate order form
    let newOrder = generateOrderForNewForm(args.listForm, formOrigin.type, args.projectInuseId);

    if (
        args.formEdit.type === Constant.FORM_TYPE.FORM_KNOWLEDGE ||
        args.formEdit.type === Constant.FORM_TYPE.FORM_MASTER
    ) {
        if (args.settingMasterKnowledge === 0) {
            formOrigin.type = Constant.FORM_TYPE.FORM_KNOWLEDGE;
        } else {
            formOrigin.type = Constant.FORM_TYPE.FORM_MASTER;
        }

        if (args.settingReviewFlag) {
            formOrigin.reviewFlag = true;
        } else {
            formOrigin.reviewFlag = false;
        }
        formOrigin.isSynonym = getDefaultSynonymSettingWhenDuplicateForm(formOrigin.isSynonym, formOrigin.type, args.corporationDetail, args.projectDetail);
    }

    const createFormData = {
        usage: objCreateformData.newUsage ? objCreateformData.newUsage : formOrigin.usage,
        name: JSON.stringify({
            jp: {
                A: 'F',
                text: formName
            }
        }),
        affiliationOrganization: args.corporationId,
        affiliationProject: args.projectInuseId,
        affiliationField: '',
        creator: args.userId,
        updator: args.userId,
        type: formOrigin.type,
        viewForCustomer: JSON.stringify({}),
        definition: Constant.FORM_DEFINITION.USER,
        explanation: JSON.stringify({}),
        usingProjects: [args.projectInuseId],
        usingTickets: JSON.stringify({}),
        order: JSON.stringify({
            [args.projectInuseId]: newOrder
        }),
        shareRange: objCreateformData.newShareRange
            ? objCreateformData.newShareRange
            : formOrigin.shareRange,
        shareOption: objCreateformData.newShareOption
            ? objCreateformData.newShareOption
            : formOrigin.shareOption,

        chatPermission: objCreateformData.chatPermission
            ? objCreateformData.chatPermission
            : formOrigin.chatPermission,
        editPermission: objCreateformData.editPermission
            ? objCreateformData.editPermission
            : formOrigin.editPermission,
        viewPermission: objCreateformData.viewPermission
            ? objCreateformData.viewPermission
            : formOrigin.viewPermission,
        createTicketForOwnerPermission: objCreateformData.createTicketForOwnerPermission
            ? objCreateformData.createTicketForOwnerPermission
            : formOrigin.createTicketForOwnerPermission,
        additionalCreateTicketForOwnerPermission: objCreateformData.additionalCreateTicketForOwnerPermission
            ? objCreateformData.additionalCreateTicketForOwnerPermission
            : [],
        reviewFlag: formOrigin.reviewFlag,
        isSynonym: formOrigin.isSynonym,
        // CR-2026-006: attachment auto-translation config (stored on Form schema fields)
        autoTranslateAttachment: args.autoTranslateAttachment ? true : false,
        translateSourceLang: args.translateSourceLang || '',
        translateTargetLangs: !Utils.isEmptyArray(args.translateTargetLangs) ? args.translateTargetLangs : []
    };

    // let createFormResult = await createFormsData(args.API, createFormData);
    // create form with api create new field
    let formCreateParams = [
        {
            field: createFormData,
            itemList: []
        }
    ];

    // =================== START DATA SANITIZATION ===================

    // 1. Sanitize `prepareParamsAddField` to create `sanitizedFieldList`
    const sanitizedFieldList = Array.isArray(prepareParamsAddField)
    ? prepareParamsAddField.map(item => ({
        field: mapToCreateFormNewFieldRequest(item.field),
        itemList: Array.isArray(item.itemList)
            ? item.itemList.map(subItem => mapToCreateFormNewFieldRequest(subItem))
            : [],
    })).filter(item => item.field) // Filter out any invalid fields after sanitization
    : []; // Return an empty array if it's not an array

    // 2. Sanitize `formCreateParams` to create `sanitizedFormParams`
    const sanitizedFormParams = Array.isArray(formCreateParams)
    ? formCreateParams.map(item => ({
        field: mapToCreateFormNewFieldRequest(item.field),
        itemList: Array.isArray(item.itemList)
            ? item.itemList.map(subItem => mapToCreateFormNewFieldRequest(subItem))
            : [],
    })).filter(item => item.field)
    : [];

    // =================== END DATA SANITIZATION ===================

    let requestData = {
        fieldList: sanitizedFieldList,
        listFieldAddToForm: JSON.stringify(listFieldAddToForm),
        projectInuseId: args.projectInuseId,
        userId: args.userId,
        formCreateParams: sanitizedFormParams,
        settingTitle: JSON.stringify(settingTitle),
        titleLineNumber: args.titleLineNumber,
        corporationId: args.corporationId,
        method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.CREATE_NEW_FORM,
        splitPdf: args.splitPdf,
    };

    if (args.formEdit.type === Constant.FORM_TYPE.FORM_REQ_QA) {
        requestData.isAllowCustomerChangeStatus = formOrigin?.isAllowCustomerChangeStatus
    }
    const result = await updateFormField(args.API, requestData);
    
    let {
        listFieldAddToFormResponse,
        listFieldUpdateSharePermission,
        fieldDataAddNew,
        createFormResult
    } = result;
    fieldDataAddNew = Utils.convertJSONDataToObject(fieldDataAddNew);
    listFieldAddToFormResponse = Utils.convertJSONDataToObject(listFieldAddToFormResponse);
    createFormResult = Utils.convertJSONDataToObject(createFormResult);
    listFieldUpdateSharePermission = Utils.convertJSONDataToObject(listFieldUpdateSharePermission);

    args.setFieldList([]);
    args.setListFieldAddToForm(listFieldAddToFormResponse);

    if (!Utils.isEmptyArray(fieldDataAddNew)) {
        fieldListInState = [...fieldDataAddNew, ...fieldListInState];
    }

    if (!Utils.isEmptyArray(listFieldUpdateSharePermission)) {
        fieldListInState.forEach(item => {
            let index = Utils.findIndexInArrayById(item.id, listFieldUpdateSharePermission);
            if(index !== -1) {
                if (item.id === listFieldUpdateSharePermission[index].id) {
                    item.usage = listFieldUpdateSharePermission[index].usage;
                    item.shareOption = listFieldUpdateSharePermission[index].shareOption;
                    item.shareRange = listFieldUpdateSharePermission[index].shareRange;
                    item.usingForms = JSON.parse(listFieldUpdateSharePermission[index].usingForms);
                }
            }
        });
    }

    let listCustomFieldAddToForm = listFieldAddToFormResponse.filter(field =>
        [Constant.FORM_DEFINITION.USER, Constant.FORM_DEFINITION.MASTER].includes(field.definition)
    );

    const formId = createFormResult?.id;
    let fieldListInStateClone = cloneDeep(fieldListInState);
    listCustomFieldAddToForm.forEach(field => {
        let usingForms = !Utils.isEmptyObject(field.usingForms) ? field.usingForms : {};
        usingForms[formId] = {
            active: Constant.FIELD_USING_FORMS.ACTIVE,
            hasValue: Constant.FIELD_USING_FORMS.NO_VALUE
        };

        let index = Utils.findIndexInArrayById(field.id, fieldListInState);
        if (index >= 0) {
            fieldListInStateClone[index].usingForms = usingForms;
        }
    });

    args.setFieldListInState(fieldListInStateClone);
    let newFormList = await getListFormByCorporation(args.API, args.corporationId, args.projectDetail);
    args.setFormList(newFormList);
    args.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
    args.setIsLoading(false);
    args.enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
};

export const getForceActiveSystemFieldByFormType = (argsCommon) => {
    let forceActiveSystemFieldByFormType = [...ForceActiveSystemFields];

    forceActiveSystemFieldByFormType = forceActiveSystemFieldByFormType.filter(sys => ![Constant.SYSTEM_FIELD.OUTLINE, Constant.SYSTEM_FIELD.ATTACHMENTS].includes(sys));
    switch (argsCommon.addFormType) {
        case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
            forceActiveSystemFieldByFormType = forceActiveSystemFieldByFormType.filter(
                sys => ![Constant.SYSTEM_FIELD.PERSON_IN_CHARGE].includes(sys)
            );
            break;
        case Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
            forceActiveSystemFieldByFormType = forceActiveSystemFieldByFormType.filter(
                sys =>
                    ![
                        Constant.SYSTEM_FIELD.PERSON_IN_CHARGE,
                        Constant.SYSTEM_FIELD.AI_PROMPT_BODY,
                        Constant.SYSTEM_FIELD.APPLY_AI_PROMPT,
                        Constant.SYSTEM_FIELD.AI_PROMPT_APPLICATION_TARGET,
                        Constant.SYSTEM_FIELD.LIST_OF_SYNONYMS,
                        Constant.SYSTEM_FIELD.AI_BASIC_INFO_TRANSMISSION,
                        Constant.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS,
                        Constant.SYSTEM_FIELD.AI_TELEPHONE_GREETING,
                    ].includes(sys)
            );
            break;
        default:
            break;
    }
    return forceActiveSystemFieldByFormType
}

/**
 * Set expand more field
 * @param {*} argsCommon 
 * @param {*} currentField 
 * @param {*} regionDropId
 * @returns 
 */
export const setExpandMoreField = (argsCommon, currentField, regionDropId) => {
    let isShowInfoNewStatus = currentField.isShowInfo ? false : true;
    // update add field list
    let cloneFieldAddList = [...argsCommon.fieldAddList];
    let indexInFieldAddList = Utils.findIndexInArrayById(currentField.id, cloneFieldAddList);
    if (indexInFieldAddList === -1) {
        let newCurrentField = { ...currentField };
        newCurrentField.isShowInfo = isShowInfoNewStatus;
        cloneFieldAddList.push(newCurrentField);
        argsCommon.setFieldAddList(cloneFieldAddList);
    } else {
        cloneFieldAddList[indexInFieldAddList].isShowInfo = isShowInfoNewStatus;
        argsCommon.setFieldAddList(cloneFieldAddList);
    }

    // Check here if force active sysfield then set regiondropid
    regionDropId = currentField.isUsingForm ? Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION : Constant.FORM_MANAGEMENT_SCREEN.FIELD_IN_PROJECT_REGION;
    let forceActiveSystemFieldByFormType = getForceActiveSystemFieldByFormType(argsCommon)

    if (
        forceActiveSystemFieldByFormType.includes(currentField.sysField) ||
        currentField.type === Constant.FORM_TYPE.FIELD_WORKFLOW
    ) {
        regionDropId = Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION;
    }

    // set regionDropId
    argsCommon.setRegionDropIdBlock(regionDropId);

    // Update in currentAddField
    if (argsCommon?.currentAddField?.id === currentField) {
        argsCommon.currentAddField.isShowInfo = isShowInfoNewStatus;
    }

    switch (regionDropId) {
        case Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION:
            // find index in fieldList using form
            let fieldListInUsingForm = cloneDeep(argsCommon.listFieldAddToForm);
            let indexInFieldListUsingForm = Utils.findIndexInArrayById(currentField.id, fieldListInUsingForm);

            if (indexInFieldListUsingForm === -1) {
                let name = cloneDeep(argsCommon.fieldAddList[indexInFieldAddList].name);
                let isUsingProject = argsCommon.fieldAddList[indexInFieldAddList].isUsingProject;

                // close show more
                updateParentFieldList(argsCommon, currentField, name, isUsingProject);

                // remove item in list
                let fieldTypeSelectedList = cloneDeep(argsCommon.fieldTypeSelectedList);
                fieldTypeSelectedList = Utils.removeItemInArrayById(currentField.id, fieldTypeSelectedList);
                argsCommon.setFieldTypeSelectedList(fieldTypeSelectedList);
            } else {
                fieldListInUsingForm[indexInFieldListUsingForm].isShowInfo = isShowInfoNewStatus;
                fieldListInUsingForm[indexInFieldListUsingForm].isUsingForm = true;
                let name = cloneDeep(argsCommon.fieldAddList[indexInFieldAddList]?.name);
                if(!Utils.isEmpty(name)){
                    fieldListInUsingForm[indexInFieldListUsingForm].name = name;
                }

                argsCommon.setListFieldAddToForm(fieldListInUsingForm);
            }
            break;
        case Constant.FORM_MANAGEMENT_SCREEN.FIELD_IN_PROJECT_REGION:
            // find index in fieldList using project
            let fieldListInUsingProject = cloneDeep(argsCommon.listFieldInProject);
            let indexInFieldListUsingProject = Utils.findIndexInArrayById(currentField.id, fieldListInUsingProject);

            if (indexInFieldListUsingProject === -1) {
                let name = cloneDeep(argsCommon.fieldAddList[indexInFieldAddList].name);
                let isUsingProject = argsCommon.fieldAddList[indexInFieldAddList].isUsingProject;

                // close show more
                updateParentFieldList(argsCommon, currentField, name, isUsingProject);

                // remove item in list
                let fieldTypeSelectedList = cloneDeep(argsCommon.fieldTypeSelectedList);
                fieldTypeSelectedList = Utils.removeItemInArrayById(currentField.id, fieldTypeSelectedList);
                argsCommon.setFieldTypeSelectedList(fieldTypeSelectedList);
            } else {
                fieldListInUsingProject[indexInFieldListUsingProject].isShowInfo = isShowInfoNewStatus;
                fieldListInUsingProject[indexInFieldListUsingProject].isUsingForm = false;
                let name = cloneDeep(argsCommon.fieldAddList[indexInFieldAddList]?.name);
                if(!Utils.isEmpty(name)){
                    fieldListInUsingProject[indexInFieldListUsingProject].name = name;
                }
                argsCommon.setListFieldInProject(fieldListInUsingProject);
            }
            break;
        default:
            break;
    }
};




/**
 * Remove field in list by regionDropId
 * @param {*} argsCommon 
 * @param {*} currentField 
 * @param {*} regionDropId 
 * @returns dropData
 */
export const removeFieldInListByRegionDropId = (argsCommon, currentField, regionDropId) => {
    switch (regionDropId) {
        case Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION:
            // find index in fieldList using form
            let fieldListInUsingForm = cloneDeep(argsCommon.listFieldAddToForm);
            let indexInFieldListUsingForm = Utils.findIndexInArrayById(currentField.id, fieldListInUsingForm);
            if (indexInFieldListUsingForm === -1) {
                return;
            }

            // Remove field in field list state
            fieldListInUsingForm.splice(indexInFieldListUsingForm, 1);
            argsCommon.setListFieldAddToForm(fieldListInUsingForm);

            let fieldAddListClone = cloneDeep(argsCommon.fieldAddList);
            if(Utils.findIndexInArrayById(currentField.id, fieldAddListClone) !== -1){
                let fieldAddList = Utils.removeItemInArrayById(currentField.id, fieldAddListClone);
                argsCommon.setFieldAddList(fieldAddList);
            }

            break;
        case Constant.FORM_MANAGEMENT_SCREEN.FIELD_IN_PROJECT_REGION:
            // find index in fieldList using project
            let fieldListInUsingProject = cloneDeep(argsCommon.listFieldInProject);
            let indexInFieldListUsingProject = Utils.findIndexInArrayById(currentField.id, fieldListInUsingProject);
            if (indexInFieldListUsingProject === -1) {
                return;
            }

            // Remove field in field list state
            fieldListInUsingProject.splice(indexInFieldListUsingProject, 1);
            argsCommon.setListFieldInProject(fieldListInUsingProject);
            break;
        default:
            return;
    }
};



/**
 * Handler duplicate field
 * @param {*} argsAll 
 * @param {*} field 
 * @param {*} regionDropId
 */
export const duplicateField = (argsAll, field, regionDropId) => {
    regionDropId = field.isUsingForm ? Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION : Constant.FORM_MANAGEMENT_SCREEN.FIELD_IN_PROJECT_REGION;
    // update regionDropIdBlock
    argsAll.setRegionDropIdBlock(regionDropId);

    let cloneField = cloneDeep(field);

    // remove time not clone
    delete cloneField.createdAt;
    delete cloneField.updatedAt;
    delete cloneField.hasValue;
    delete cloneField.usingForms;

    let nameCloneField;
    try {
        nameCloneField = JSON.parse(cloneField.name);
    } catch (err) {
        nameCloneField = { ...cloneField.name };
    }

    nameCloneField[Constant.LANGUAGE_TYPE.JP] = {
        A: 'F',
        text: `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name)} - Copy`
    };


    // update data of clone field
    cloneField.id = Date.now().toString();
    cloneField.affiliationProject = argsAll.projectDetail.id;
    cloneField.creator = argsAll.userDetail.id;
    cloneField.updator = argsAll.userDetail.id;
    cloneField.isProjectInuse = true;
    cloneField.usingProjects = [argsAll.projectDetail.id];
    cloneField.isShowInfo = true;
    cloneField.addToForm = false;
    cloneField.clientFieldType = Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD;
    cloneField.name = nameCloneField;
    cloneField.isUsingProject = true;
    cloneField.usingTickets = JSON.stringify({});
    cloneField.order = Utils.isEmpty(cloneField.order) ? JSON.stringify({}) : cloneField.order;
    cloneField.relatedMasterForm = Constant.RELATED_MASTER_FORM_DEFAULT;

    // add newField to drag and drop state
    let listFieldAddToForm = argsAll.listFieldAddToForm;
    let listFieldInProject = argsAll.listFieldInProject;

    //
    if (regionDropId === Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION) {
        let indexInFieldAddForm = Utils.findIndexInArrayById(field.id, listFieldAddToForm);
        cloneField.addToForm = true;
        listFieldAddToForm.splice(indexInFieldAddForm + 1, 0, cloneField);
    } else {
        let indexInFieldInProject = Utils.findIndexInArrayById(field.id, listFieldInProject);
        listFieldInProject.splice(indexInFieldInProject + 1, 0, cloneField);
    }
    argsAll.setListFieldAddToForm([...listFieldAddToForm]);
    argsAll.setListFieldInProject([...listFieldInProject]);

    // update fieldAddList
    let fieldAddList = [...argsAll.fieldAddList];
    fieldAddList.push(cloneField);
    argsAll.setFieldAddList(fieldAddList);
};



/**
 * Get display form typ
 * @param {*} formType 
 * @returns formType
 */
export const getDisplayTextFormType = (formType) => {
    let displayText = "";
    switch (formType) {
        case Constant.FORM_TYPE.FORM_REQ_QA:
            displayText = "問い合わせ";
            break;
        case Constant.FORM_TYPE.FORM_REQ_NOTICE:
            displayText = "お知らせ";
            break;
        case Constant.FORM_TYPE.FORM_TASK:
            displayText = "課題";
            break;
        case Constant.FORM_TYPE.FORM_KNOWLEDGE:
            displayText = "ナレッジ";
            break;
        default:
    }

    return displayText;
};

export const handleOnClickDeleteForm = async (argsAll, item) => {
    let listForm = cloneDeep(argsAll.listForm);
    let formIndex = Utils.findIndexInArrayById(item.id, listForm);

    if (Utils.isEmptyArray(listForm) || formIndex === -1) return;
    argsAll.setOpenConfirmModal(false);
    argsAll?.setIsLoading(true);
    let currentFormData = await getFormById(argsAll?.API, item.id,null,true);

    if (Utils.isEmptyObject(currentFormData)) {
        argsAll?.setIsOpenModalReloadPage(true);
        argsAll?.setIsLoading(false);
        return;
    }
    if(currentFormData.isUsingInCategories){
        argsAll.setIsOpenCannotDeletePopup(true);
        argsAll?.setIsLoading(false);
        return
    };

    if (!currentFormData || isFormUsedCreateTicket(currentFormData)) {
        if (currentFormData?.usingTickets) {
            listForm[formIndex].usingTickets = currentFormData.usingTickets;
            argsAll.setListForm([...listForm]);
        }
        argsAll?.setIsLoading(false);
        return;
    }

    const requestData = {
        formEditId: item.id,
        corporationId: argsAll.projectInuseDetail.affiliationOrganization,
        method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.DELETE_FORM
    }
    const result = await updateFormField(argsAll.API, requestData);

    if (!result.status) {
        argsAll?.setIsOpenModalReloadPage(true);
        argsAll?.setIsLoading(false);
        return;
    }
    
    listForm.splice(formIndex, 1);
    argsAll.setListForm([...listForm]);
    argsAll?.setIsLoading(false);
};

export const checkDisplayCreateTicketForOwnerAdditionalPermission = (basePermission) => {
    if(basePermission.includes(Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.ALL_ORG)){
        return false
    }

    if(!basePermission.includes(Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.IN_ORG)){
        return true
    }

    if(!basePermission.includes(Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.B2B_CUSTOMER)){
        return true
    }

    if(!basePermission.includes(Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.B2B_SUPPORT)){
        return true
    }

    return false
}

const isFormUsedCreateTicket = (formData) => {
    if (!formData || Utils.isEmptyObject(formData)) return true;

    let usingTicketsToString = formData.usingTickets.toString();
    if (usingTicketsToString.includes('req') || usingTicketsToString.includes('knowledge')) {
        return true;
    }
    return false;
}


export const isDisplaySplitPDF = (corporationDetail, formType) => {
    let corporationLimitValue = corporationDetail.limitValue;
    let inviterLimitValue = corporationDetail.inviterSetting ? Utils.convertJSONDataToObject(corporationDetail.inviterSetting) : {};

    return (
        (corporationLimitValue?.convertPDF === Constant.PDF_FUNCTION.ON ||
            inviterLimitValue.convertPDF === Constant.PDF_FUNCTION.ON) &&
        (formType === Constant.FORM_TYPE.FORM_KNOWLEDGE ||
            formType === Constant.FORM_TYPE.FORM_MASTER)
    );
};

/**
 * CR-2026-006: whether the organization has both Multilingual Support and File Translation
 * enabled (permission + org toggle). Shared org-level gate for the auto-translate feature.
 * Handles GUEST/GUEST_DESK corps by reading inviterSetting instead of limitValue directly.
 */
export const isOrgAutoTranslateEnabled = (corporationDetail) => {
    if (Utils.isEmptyObject(corporationDetail)) return false;
    return (
        CorporationUtils.isEnableSettingMultiLanguage(corporationDetail) &&
        CorporationUtils.isEnableSettingFileTranslation(corporationDetail)
    );
};

/**
 * CR-2026-006: display the attachment auto-translation option only when the organization
 * has both Multilingual Support and File Translation enabled (permission + org toggle),
 * AND the project has File Translation enabled (project-level toggle).
 * Applies to both Knowledge/Master and Ticket format types (BR-1, AC-6).
 */
export const isDisplayAutoTranslate = (corporationDetail, formType, projectInuseDetail) => {
    const supportedFormTypes = [
        Constant.FORM_TYPE.FORM_KNOWLEDGE,
        Constant.FORM_TYPE.FORM_MASTER,
        Constant.FORM_TYPE.FORM_REQ,
        Constant.FORM_TYPE.FORM_REQ_QA,
        Constant.FORM_TYPE.FORM_TASK,
        Constant.FORM_TYPE.FORM_REQ_NOTICE
    ];

    return isOrgAutoTranslateEnabled(corporationDetail)
        && supportedFormTypes.includes(formType)
        && CorporationUtils.isEnableSettingFileTranslationAttachment(corporationDetail, projectInuseDetail);
};


/**
 * isDisplaySettingSynonymSearch
 * @param {*} corporationDetail 
 * @param {*} formType 
 * @param {*} projectInuseDetail 
 * @returns 
 */
export const isDisplaySettingSynonymSearch = (corporationDetail, formType, projectInuseDetail) => {
    if (!corporationDetail || !formType || !projectInuseDetail) return false;
    if (![Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(formType)) return false;
    // if (formEdit && formEdit.affiliationOrganization !== corporationDetail.id) return false;

    let projectSetting = Utils.convertJSONDataToObject(projectInuseDetail.projectSetting);
    if (!projectSetting || !projectSetting.usingSynonym) return false;

    let corporationLimitValue = corporationDetail.limitValue;
    let inviterSetting = corporationDetail.inviterSetting
        ? Utils.convertJSONDataToObject(corporationDetail.inviterSetting)
        : {};

    return corporationLimitValue?.synonymSearch || inviterSetting.synonymSearch ? true : false;
};


export const onChangeSettingSynonym = (event, setIsSynonym, setIsChangeData, argsAll) => {
    let newValue = event.target.checked;
    setIsSynonym(newValue ? true : false); 
    setIsChangeData(true);

    //check reset values when turn on synonym func.

    if (newValue ) {
        // Remove attachments field from list field in form
        let listFieldAddToForm = argsAll.listFieldAddToForm;
        let attachmentsField = listFieldAddToForm.find(field => field.sysField === 'attachments');
        if (!Utils.isEmptyObject(attachmentsField)) {
            onChangeItemInForm(argsAll, attachmentsField, Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION);
        }
        
        //auto active synonym field
        let listOfSynonymsField = argsAll.listFieldInProject.find(field => field.sysField === 'listOfSynonyms');
        if (!Utils.isEmptyObject(listOfSynonymsField)) {
            onChangeItemInForm(argsAll, listOfSynonymsField, Constant.FORM_MANAGEMENT_SCREEN.FIELD_IN_PROJECT_REGION);
        }

        //clear values of permission when turn on.
        argsAll.setSelectedViewPermissions([
            Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.CREATOR,
            Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_PROJECT
        ]);
        argsAll.setSelectedEditPermissions([
            Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.CREATOR_ONLY,
            Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER
        ]);
        argsAll.setCreateTicketForOwnerBasePermission([
            Constant.KNOWLEDGE_FORM_CREATE_TICKET_FOR_OWNER_PERMISSION_TEXT.IN_PROJECT
        ]);
        argsAll.setAdditionalCreateTicketForOwnerPermission([]);
        argsAll.setSelectedChatPermissions(Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT)
    }
}


export const isDisplayPinIconActiveFieldToForm = (regionDropId, field, isSynonym = false) => {
    return regionDropId === Constant.FORM_MANAGEMENT_SCREEN.FIELD_IN_PROJECT_REGION
}

export const isDisplayPinIconInactiveFormToField = (
    field,
    isSynonym = false,
    forceActiveSystemField,
    regionDropId = Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION
) => {
    if(regionDropId !== Constant.FORM_MANAGEMENT_SCREEN.FIELD_ADD_TO_FORM_REGION) {
        return false;
    }

    if(field.sysField === 'listOfSynonyms' && isSynonym) {
        return false;
    }

    if(AISystemField.includes(field.sysField)) {
        return false;
    }

    return (
        !forceActiveSystemField.includes(field.sysField) &&
        field.type !== Constant.FORM_TYPE.FIELD_WORKFLOW
    );
};

export const getDefaultSynonymSettingWhenDuplicateForm = (formOriginSynonym, formType, corporationDetail, projectInuseDetail) => {
    if (!formOriginSynonym || !formType || ![Constant.FORM_TYPE.FORM_KNOWLEDGE, Constant.FORM_TYPE.FORM_MASTER].includes(formType)) return false;

    if (isDisplaySettingSynonymSearch(corporationDetail, formType, projectInuseDetail)) {
        return true;
    }
    
    return false;
}

export const handleHiddenSysField = (fieldList, formType) => {
    if (Utils.isEmptyArray(fieldList) || !formType) return [];
    const aiAutoSysFields = Object.values(Constant.AI_AUTO.SYSTEM_FIELD);
    const sdAutoSysFields = Object.values(Constant.SD_AUTO.SYSTEM_FIELD);
    const businessAppSysFields = [
        Constant.SYSTEM_FIELD.BUSINESS_APP_NAME,
        Constant.SYSTEM_FIELD.BUSINESS_APP_NAME_PAGE,
        Constant.SYSTEM_FIELD.BUSINESS_APP_DISPLAY_SIDE_BAR,
        Constant.SYSTEM_FIELD.BUSINESS_APP_USE_RANGE
    ];
    const drilldownSysFields = Object.values(Constant.ONLY_DRILLDOWN_SYSTEM_FIELD.SYSTEM_FIELD);
    const aiTelephonePromptSystemFields = Object.values(Constant.AI_TELEPHONE_PROMPT_SYSTEM_FIELD);
    let hiddenSysField = [
        'ticketId',
        'ticketType',
        'parent',
        'children',
        ...drilldownSysFields,
        ...aiAutoSysFields,
        ...sdAutoSysFields,
        ...businessAppSysFields,
        Constant.SYSTEM_FIELD.MCP_SERVER_SETTING,
        ...aiTelephonePromptSystemFields
    ];
    
    switch (formType) {
        case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_QA:
        case Constant.FILTER_LIST_FORM_TYPE.FORM_TASK:
            hiddenSysField = [
                ...hiddenSysField,
                'escalationOriginCustomer',
                'escalationTarget',
                'listOfSynonyms'
            ];
            break;
        case Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
            hiddenSysField = [...hiddenSysField, 'listOfSynonyms'];
            break;
        default:
            break;
    }

    if([Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_QA, Constant.FILTER_LIST_FORM_TYPE.FORM_TASK, Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE, Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE, Constant.FILTER_LIST_FORM_TYPE.FORM_MASTER].includes(formType)){
        let newField = [];
        fieldList?.forEach((field,index)=> {
            if(!hiddenSysField.includes(field.sysField)){
                let fieldClone = cloneDeep(field)
                fieldClone.indexInList = index
                newField.push(fieldClone)
            }
        })
        return newField
    }


    return fieldList;
};

export const activeFormForDuplicate = async (API, formList, selectedProjectId, formDetail, setFormList) => {
    let newOrderValue = formList.length;

    let newOrder = {
        [selectedProjectId]: newOrderValue + 1
    };
    let order = formDetail.order;
    order = { ...order, ...newOrder };

    let usingProjects = formDetail.usingProjects;

    usingProjects = [...formDetail.usingProjects, selectedProjectId];

    // call edit ticket
    let updateFormData = {
        usingProjects: usingProjects,
        order: JSON.stringify(order),
        currentProjectId: selectedProjectId
    };
    
    const formIndex = formList.findIndex(form => form.id === formDetail.id);
    const updatedFormList = [...formList];
    if (formIndex !== -1) {
        const updatedForm = {
            ...formList[formIndex],
            usingProjects: [...usingProjects],
            order: JSON.stringify({ ...order })
        };
        
        updatedFormList[formIndex] = updatedForm;
    }
    setFormList(updatedFormList)

    await updateFormsData(API, formDetail.id, updateFormData);
    return true;
};

export const updateFieldCreateNewToFieldAddToForm = (fieldAddList,fieldAddToForm) => {
        let isChange = false
        if(Utils.isEmptyArray(fieldAddList) || Utils.isEmptyArray(fieldAddToForm)) return {
                isChange: isChange,
                fieldAddToForm: []
        };
        let fieldAddToFormClone = cloneDeep(fieldAddToForm);
        const listFieldCreateNew = fieldAddList?.filter(field => field.id?.includes('dummy_'));
        if(Utils.isEmptyArray(listFieldCreateNew)) return {
            isChange: isChange,
            fieldAddToForm: []
        }
        for (let index = 0; index < listFieldCreateNew.length; index++) {
            const fieldDummy = listFieldCreateNew[index];
            const indexOfField = fieldAddToForm.findIndex(field => field.id === fieldDummy.id);
            if(indexOfField !== -1){
                fieldAddToFormClone[indexOfField] = fieldDummy;
                isChange = true
            }
        }

        return{
            isChange: isChange,
            fieldAddToForm: fieldAddToFormClone
        }
}

/**
 * Converts a frontend field object into a backend-safe DTO, strictly adhering
 * to the `CreateFormNewFieldRequest` GraphQL schema.
 * This function removes redundant fields, converts objects to JSON strings where
 * necessary, and ensures important fields have default values to prevent null
 * errors on the backend.
 *
 * @param {object} fieldObject The field object from the frontend state.
 * @returns {object | null} A sanitized object that conforms to the schema, or null if the input is invalid.
 */
export const mapToCreateFormNewFieldRequest = (fieldObject) => {
    if (!fieldObject || typeof fieldObject !== 'object') {
        console.error("Input for mapToCreateFormNewFieldRequest is not a valid object:", fieldObject);
        return null;
    }

    // List of all fields allowed in the CreateFormNewFieldRequest schema
    const allowedKeys = new Set([
        'usage', 'id', 'isUsingProject', 'addToForm', 'name', 'affiliationOrganization',
        'affiliationProject', 'affiliationField', 'creator', 'createdAt', 'updator', 'type',
        'structure', 'viewForCustomer', 'definition', 'explanation', 'usingProjects',
        'usingTickets', 'order', 'hitNumber', 'shareRange', 'relatedMasterForm',
        'settingAutoAdd', 'sysField', 'shareOption', 'newShareOption', 'newShareRange',
        'newUsage', 'viewPermission', 'editPermission', 'chatPermission',
        'createTicketForOwnerPermission', 'additionalCreateTicketForOwnerPermission',
        'reviewFlag', 'dummyId', 'promptKnowledgeFormFlag', 'isSynonym', 'definitionVariant',
        'isUsingInCategories', 'formCategories', 'isAllowCustomerChangeStatus'
    ]);

    // Fields that need to be converted to a JSON string
    const stringifyKeys = new Set(['name', 'structure', 'viewForCustomer', 'explanation', 'usingTickets', 'order', 'formCategories']);

    const sanitizedDto = {};

    // 1. Only take allowed fields from the original object
    for (const key in fieldObject) {
        if (allowedKeys.has(key)) {
            sanitizedDto[key] = fieldObject[key];
        }
    }

    // 2. Convert object values to JSON strings
    for (const key of stringifyKeys) {
        if (sanitizedDto.hasOwnProperty(key) && typeof sanitizedDto[key] === 'object' && sanitizedDto[key] !== null) {
            sanitizedDto[key] = JSON.stringify(sanitizedDto[key]);
        }
    }

    // 3. Ensure important object-like fields have a default value if missing to prevent backend errors
    const defaultStringifiedObjectKeys = ['structure', 'viewForCustomer', 'explanation', 'order'];
    for (const key of defaultStringifiedObjectKeys) {
        if (sanitizedDto[key] === undefined || sanitizedDto[key] === null) {
            sanitizedDto[key] = '{}';
        }
    }
    
    // 4. Ensure required fields (`!`) exist and log a warning if they don't
    if (!sanitizedDto.name) {
         console.warn("Field object is missing the required 'name' field:", fieldObject);
    }
    if (!sanitizedDto.usage) {
        console.warn("Field object is missing the required 'usage' field:", fieldObject);
    }
    if (!sanitizedDto.affiliationOrganization) {
        console.warn("Field object is missing the required 'affiliationOrganization' field:", fieldObject);
    }
    if (!sanitizedDto.affiliationProject) {
        console.warn("Field object is missing the required 'affiliationProject' field:", fieldObject);
    }

    return sanitizedDto;
};

// Determine invalid fields based on form type
export const getInvalidSysFields = formType => {
    const { FILTER_LIST_FORM_TYPE } = Constant;

    switch (formType) {
        case FILTER_LIST_FORM_TYPE.FORM_REQ_QA:
            return [
                ...TELEPHONE_FIELDS,
                ...COMMON_AI_FIELDS,
                ...KB_KNOWLEDGE_FIELDS,
                Constant.SYSTEM_FIELD.LIST_OF_SYNONYMS
            ];

        case FILTER_LIST_FORM_TYPE.FORM_TASK:
        case FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE:
            return [
                ...TELEPHONE_FIELDS,
                ...COMMON_ESCALATION_FIELDS,
                ...COMMON_AI_FIELDS,
                ...KB_KNOWLEDGE_FIELDS,
                Constant.SYSTEM_FIELD.LIST_OF_SYNONYMS
            ];

        case FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE:
            return [...TELEPHONE_FIELDS, ...COMMON_ESCALATION_FIELDS, ...COMMON_AI_FIELDS, ...KB_KNOWLEDGE_FIELDS];

        default:
            return [];
    }
};
